import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { faPlus, faMinus, faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt, faTimesCircle, faCalendarAlt, faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { formatDate } from '@angular/common';
import { CalculatorService } from 'src/app/shared/services/calculator-services/calculator-standard-os.service';
import { GoldenAutumn } from 'src/app/shared/models/calculator-models/golden-autumn.model';
import { of, Subscription } from 'rxjs';
import { GoldenAutumnExport } from 'src/app/shared/models/export-models/golden-autumn-export.model';
import { BasicInformations } from 'src/app/shared/models/basic-informations.model';
import { ExportCalculatorService } from 'src/app/shared/services/calculator-services/calculator-export.service';
import { ProductRoleService } from 'src/app/shared/services/admin-services/product-role.service';
import { BasicInformationsService } from 'src/app/shared/services/basic-informations.service';
import { Beneficiaries } from 'src/app/shared/models/offer-models/beneficiaries.model';
import { DigitalService } from 'src/app/shared/services/digital.service';
import { UserService } from 'src/app/shared/services/admin-services/user.service';
import { OfferService } from 'src/app/shared/services/offer-services/offer.service';
import { OccupationService } from 'src/app/shared/services/admin-services/occupation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BankService } from 'src/app/shared/services/admin-services/bank.service';
import { Filter } from 'src/app/shared/models/filter.model';
import { PLATIMATICQuestionnaire } from 'src/app/shared/models/offer-models/platimatik-questionnaire.model';
import { SPNFTQuestionnaire } from 'src/app/shared/models/offer-models/spnft-questionnaire.model';
import { FATCAQuestionnaire } from 'src/app/shared/models/offer-models/fatca-questionnaire.model';
import { OfferInsuree } from 'src/app/shared/models/offer-models/offer-insuree.model';
import { OfferClient } from 'src/app/shared/models/offer-models/offer-client.model';
import { StandardOSOffer } from 'src/app/shared/models/offer-models/standard-os-offer.model';
import { Router } from '@angular/router';
import { RoleSendService } from 'src/app/shared/services/role-send.service';
import { RiskAssessment } from 'src/app/shared/models/offer-models/risk-assessment.model';
import { RemoveInfoService } from 'src/app/shared/services/remove-info.service';
import { FillDraftOfferService } from 'src/app/shared/services/fill-draft.service';
import { EditOfferService } from 'src/app/shared/services/edit-offer.service';
import { SaveDraftService } from 'src/app/shared/services/save-draft.service';
import { SendInfoService } from 'src/app/shared/services/send-info.service';

@Component({
  selector: 'app-golden-autumn',
  templateUrl: './golden-autumn.component.html',
  styleUrls: ['./golden-autumn.component.sass']
})
export class GoldenAutumnComponent implements OnInit, OnDestroy {
  @ViewChild('insuredBlock', { static: false }) private insuredBlock;
  @ViewChild('usersBlock', { static: false }) private usersBlock;
  @ViewChild('healthBlock', { static: false }) private healthBlock;
  @ViewChild('spnftBlock', { static: false }) private spnftBlock;
  @ViewChild('platimatikBlock', { static: false }) private platimatikBlock;
  @ViewChild('fatcaBlock', { static: false }) private fatcaBlock;
  faPlus = faPlus;
  faMinus = faMinus;
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faTrashAlt = faTrashAlt;
  faTimesCircle = faTimesCircle;
  faCalendarAlt = faCalendarAlt;
  faCheckCircle = faCheckCircle;

  @ViewChild('alertModal', { static: false }) private alertModal;
  @ViewChild('emailModal', { static: false }) private emailModal;
  @ViewChild('succesModal', { static: false }) private succesModal;
  @ViewChild('accNumber', { static: false }) private accNumber;
  @ViewChild('riskFormModal', { static: false }) private riskFormModal;
  errorTitle: String;
  successTitle: String;

  sentInformation;
  basicInfo: BasicInformations;
  basicInfoSubscription: Subscription;
  roleService: Subscription;

  roleType: String = '';

  selectedPackage: number = 1;
  hideExport: Boolean = false;
  calculationDone: Boolean = false;
  supplementaryIsnuranceHideAllBool: Boolean = false;

  contractualElementsOfInsuranceBool: Boolean = true;
  basicCoveredBool: Boolean = true;
  calculcatorUsersBool: Boolean = false;
  supplementaryCoveredBool: Boolean = true;
  noticeFatcaBool: Boolean = false;
  fatcaTypeBool: Boolean = null;
  formSpnftBool: Boolean = false;
  formPlatimatikBool: Boolean = false;
  healthQuestionnaireBool: Boolean = false;
  noticePersonalityBool: Boolean = false;

  packegeOnePremiumRate: Number = null;
  packegeOneInsuranceSum: Number = null;
  packegeOneInsuranceSumDeath: Number = null;
  packegeTwoPremiumRate: Number = null;
  packegeTwoInsuranceSum: Number = null;
  packegeTwoInsuranceSumDeath: Number = null;
  packegeThreePremiumRate: Number = null;
  packegeThreeInsuranceSum: Number = null;
  packegeThreeInsuranceSumDeath: Number = null;
  packegeFourPremiumRate: Number = null;
  packegeFourInsuranceSum: Number = null;
  packegeFourInsuranceSumDeath: Number = null;
  packegeFivePremiumRate: Number = null;
  packegeFiveInsuranceSum: Number = null;
  packegeFiveInsuranceSumDeath: Number = null;
  packegeSixPremiumRate: Number = null;
  packegeSixInsuranceSum: Number = null;
  packegeSixInsuranceSumDeath: Number = null;

  packageOneThesisDiseaseFirst: Number = null;
  packageOneThesisDiseaseSecond: Number = null;
  packageOneBrokenBonesFirst: Number = null;
  packageOneBrokenBonesSecond: Number = null;
  packageOneAssisstent: Number = null;
  packageTwoThesisDiseaseFirst: Number = null;
  packageTwoThesisDiseaseSecond: Number = null;
  packageTwoBrokenBonesFirst: Number = null;
  packageTwoBrokenBonesSecond: Number = null;
  packageTwoAssisstent: Number = null;
  packageThreeThesisDiseaseFirst: Number = null;
  packageThreeThesisDiseaseSecond: Number = null;
  packageThreeBrokenBonesFirst: Number = null;
  packageThreeBrokenBonesSecond: Number = null;
  packageThreeAssisstent: Number = null;
  packageFourThesisDiseaseFirst: Number = null;
  packageFourThesisDiseaseSecond: Number = null;
  packageFourBrokenBonesFirst: Number = null;
  packageFourBrokenBonesSecond: Number = null;
  packageFourAssisstent: Number = null;
  packageFiveThesisDiseaseFirst: Number = null;
  packageFiveThesisDiseaseSecond: Number = null;
  packageFiveBrokenBonesFirst: Number = null;
  packageFiveBrokenBonesSecond: Number = null;
  packageFiveAssisstent: Number = null;
  packageSixThesisDiseaseFirst: Number = null;
  packageSixThesisDiseaseSecond: Number = null;
  packageSixBrokenBonesFirst: Number = null;
  packageSixBrokenBonesSecond: Number = null;
  packageSixAssisstent: Number = null;

  // Forma za Osigurana suma i primija
  insuredSumAndPremiumForm = new FormGroup({
    insuranceStart: new FormControl({ value: '', disabled: true }),
    insuranceEnd: new FormControl({ value: 'DOŽIVOTNO', disabled: true }),
    accessAge: new FormControl('', [Validators.required]),
    dynamicOfPayment: new FormControl('12', [Validators.required]),
    offer: new FormControl(true, []),
    proContract: new FormControl(false, []),
    terms: new FormControl(false, []),
    currencyPayment: new FormControl('0', [Validators.required]),
    currencyPayout: new FormControl('0', [Validators.required]),
    indexation: new FormControl('', [Validators.required]),
    methodPayment: new FormControl('', [Validators.required])
  })

  // Forma za cekboksove na dnu
  checkBoxesForm = new FormGroup({
    confirmVeracity: new FormControl(false, []),
    confirmData: new FormControl(false, []),
    confirmSMS: new FormControl('1', []),
    confirmEmail: new FormControl('1', [])
  })

  // Forma za dopunsko pokrice
  insuranceCoverageBool = new FormGroup({
    thesisDisease: new FormControl(false, []),
    brokenBone: new FormControl(false, []),
    assisstent: new FormControl(false, [])
  })

  // Forma za ukupnu sumu
  insuranceSumForm = new FormGroup({
    sumPremiumRate: new FormControl({ value: '', disabled: true }),
    sumYearly: new FormControl({ value: '', disabled: true })
  })

  // Lista korisnika
  insuranceUsers: Array<Beneficiaries> = [];
  // Forma za korisnike
  insuranceUserForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    remark: new FormControl('', [Validators.required]),
    role: new FormControl('', [Validators.required])
  })

  // Forma za Zdravstveni upitnik
  healthForm = new FormGroup({
    threeMonthStayAbroad: new FormControl('', [Validators.required]),
    threeMonthStayAbroadDescription: new FormControl('', [Validators.required]),
    deniedAcceptedRequest: new FormControl('', [Validators.required]),
    deniedacceptedRequestDescription: new FormControl('', [Validators.required]),
    sportActivity: new FormControl('', [Validators.required]),
    sportActivityDescription: new FormControl('', [Validators.required]),
    constantDoctorTreats: new FormControl('', [Validators.required]),
    constantDoctorTreatsDescription: new FormControl('', [Validators.required]),
    specialMedicalExamination: new FormControl('', [Validators.required]),
    specialMedicalExaminationDescription: new FormControl('', [Validators.required]),
    takingMedicines: new FormControl('', [Validators.required]),
    takingMedicinesDescription: new FormControl('', [Validators.required]),
    alcoholOrIntoxicants: new FormControl('', [Validators.required]),
    alcoholOrIntoxicantsDescription: new FormControl('', [Validators.required]),
    helpForAlcoholAddiction: new FormControl('', [Validators.required]),
    helpForAlcoholAddictionDescription: new FormControl('', [Validators.required]),
    consumeCigarettes: new FormControl('', [Validators.required]),
    consumeCigarettesDescription: new FormControl('', [Validators.required]),
    seriousIllness: new FormControl('', [Validators.required]),
    seriousIllnessDescription: new FormControl('', [Validators.required]),
    dangerAtWork: new FormControl('', [Validators.required]),
    dangerAtWorkDescription: new FormControl('', [Validators.required]),
    tenYearMedicalTests: new FormControl('', [Validators.required]),
    tenYearmedicalTestsDescription: new FormControl('', [Validators.required]),
    thirtyDaysIncapable: new FormControl('', [Validators.required]),
    thirtyDaysIncapableDescription: new FormControl('', [Validators.required]),
    levelOfInvaliditet: new FormControl('', [Validators.required]),
    levelOfInvaliditetDescription: new FormControl('', [Validators.required]),
    nameOfDoctor: new FormControl('', [Validators.required]),
    familySickness: new FormControl('', [Validators.required]),
    familySicknessDescription: new FormControl('', [Validators.required]),
    agreeToHealthQuestionnaire: new FormControl(true, [Validators.required])
  })

  // Forma za Obavestenje FATCA
  fatcaForm = new FormGroup({
    citizenshipSad: new FormControl('1', []),
    texpayerSad: new FormControl('1', []),
    insuredLegalEntitySad: new FormControl('1', []),
    insuredTaxpayerSad: new FormControl('1', []),
    insuredTenPrecentShare: new FormControl('1', []),
    insuredFinancialInstitution: new FormControl('1', [])
  })

  // Forma za Obrazac SPNFT
  spnftForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    companyName: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    legalRepresentativeFirstname: new FormControl('', []),
    legalRepresentativeLastname: new FormControl('', []),
    representativeJmbg: new FormControl('', []),
    dob: new FormControl({ value: '', disabled: true }),
    settlementob: new FormControl('', [Validators.required]),
    pib: new FormControl('', []),
    mb: new FormControl('', []),
    address: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    numberOfDocument: new FormControl('', [Validators.required]),
    typeOfDocument: new FormControl('', [Validators.required]),
    // dateOfIssuringDocument: new FormControl('', [Validators.required]),
    dateOfIssuringDocument: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    personalDocumentExpirationDate: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    placeOfIssuringDocument: new FormControl('', [Validators.required]),
    citizenship: new FormControl('', [Validators.required]),
    officialCloseFamily: new FormControl('0', []),
    closeFamilyName: new FormControl('', []),
    officialPeriod: new FormControl('', []),
    cutomerAnotherPerson: new FormControl('0', [Validators.required]),
    cutomerAnotherPersonRole: new FormControl('', [Validators.required]),
    firstnameOnBehalf: new FormControl('', [Validators.required]),
    lastnameOnBehalf: new FormControl('', [Validators.required]),
    dobOnBehalf: new FormControl({ value: '', disabled: true }),
    settlementobOnBehalf: new FormControl('', [Validators.required]),
    jmbgOnBehalf: new FormControl('', [Validators.required]),
    addressOnBehalf: new FormControl('', [Validators.required]),
    postalCodeOnBehalf: new FormControl('', [Validators.required]),
    settlementOnBehalf: new FormControl('', [Validators.required]),
    idNumberOnBehalf: new FormControl('', [Validators.required]),
    idTypeOnBehalf: new FormControl('', [Validators.required]),
    idDate: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    idPlace: new FormControl('', [Validators.required]),
    purposeOfBusinessRelation: new FormControl('', [Validators.required]),
    purposeOfBusinessRelationOther: new FormControl('', [Validators.required]),
    originOfProperty: new FormControl('', [Validators.required]),
    originOfPropertyOther: new FormControl('', [Validators.required])
  })

  // Forma za Obrazac PLATIMATIK
  platimatikForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    placeOfResidence: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    firstThreeAccountNumber: new FormControl('', [Validators.required]),
    middleAccountNumber: new FormControl('', [Validators.required]),
    lastTwoAccountNumber: new FormControl('', [Validators.required]),
    bankName: new FormControl('', [Validators.required]),
    bankBic: new FormControl('', [Validators.required]),
    validityFirstTermFrom: new FormControl({ value: '', disabled: true }),
    validityFirstTermTo: new FormControl({ value: '', disabled: true }),
    validitySecondTermFrom: new FormControl({ value: '', disabled: true }),
    validitySecondTermTo: new FormControl({ value: '', disabled: true })
    // dateOfFirstObligationsDue: new FormControl('', []),
    // dateOfLastCommitment: new FormControl('', [])
  })

  riskAssessmentForm = new FormGroup({
    question1: new FormControl('', [Validators.required]),
    question2: new FormControl('', [Validators.required]),
    question3: new FormControl('', [Validators.required]),
    question4: new FormControl('', [Validators.required]),
    question5: new FormControl('', [Validators.required]),
    question6: new FormControl('', [Validators.required]),
    question7: new FormControl('', [Validators.required]),
    question8: new FormControl('', [Validators.required]),
    question9: new FormControl('', [Validators.required]),
    question10: new FormControl('', [Validators.required]),
    question11: new FormControl('', [Validators.required]),
    question12: new FormControl('', [Validators.required]),
    question13: new FormControl('', [Validators.required]),
    question14: new FormControl('', [Validators.required]),
    question15: new FormControl('', [Validators.required]),
    question16: new FormControl('', [Validators.required]),
    question17: new FormControl('', [Validators.required]),
    question18: new FormControl('', [Validators.required]),
    question19: new FormControl('', [Validators.required]),
    question20: new FormControl('', [Validators.required]),
    question21: new FormControl('', [Validators.required]),
    question22: new FormControl('', [Validators.required]),
    question23: new FormControl('', [Validators.required]),
    question24: new FormControl('', [Validators.required]),
    question25: new FormControl('', [Validators.required]),
    question26: new FormControl('', [Validators.required]),
    question27: new FormControl('', [Validators.required]),
    question28: new FormControl('', [Validators.required]),
    question29: new FormControl('', [Validators.required]),
    unableToGetData: new FormControl('')
  })

  editSubscription: Subscription;
  draftBool: Boolean = true;
  updateDraftModelFull: StandardOSOffer;
  offerId: Number;
  premiumRatePackage: Number;
  sumInsuredPackage: Number;
  deathByAccidentPackage: Number;

  constructor(private calculatorStandard: CalculatorService, private exportService: ExportCalculatorService, private productRoleService: ProductRoleService, private basicInformationsService: BasicInformationsService, private modalService: NgbModal, private offerService: OfferService, private occupationService: OccupationService, private userService: UserService, private bankService: BankService, private digitalService: DigitalService, private router: Router, private roleSendService: RoleSendService, private removeInfoService: RemoveInfoService, private editOfferService: EditOfferService, private saveDraftService: SaveDraftService, private fillDraftOfferService: FillDraftOfferService, private sendInfoService: SendInfoService) {
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        this.roleType = res;
      }
    )

    if (this.todayDate.getDate() > 25) {
      this.todayDate.setDate(1);
      this.todayDate.setMonth(this.todayDate.getMonth() + 2);
    } else {
      this.todayDate.setDate(1);
      this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    }

    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.basicInfoSubscription = basicInformationsService.info$.subscribe(
      (res: BasicInformations) => {
        // console.log(res.data.contractorType);
        this.basicInfo = res;
        if (res.data.contractorType == '1') {
          this.fatcaTypeBool = true;
          this.spnftForm.get('pib').setValue(res.data.contractorPIB);
          this.spnftForm.get('mb').setValue(res.data.contractorID);
          this.spnftForm.get('companyName').setValue(res.data.contractorResponsibleName);
        } else if (res.data.contractorType == '2') {
          this.fatcaTypeBool = false;
          this.spnftForm.get('pib').setValue('');
          this.spnftForm.get('mb').setValue('');
          this.spnftForm.get('companyName').setValue('');
        } else if (res.data.contractorType == '') {
          this.fatcaTypeBool = null;
        }

        // console.log(res.data)
        this.spnftForm.get('firstname').setValue(res.data.contractorFirstname);
        this.spnftForm.get('lastname').setValue(res.data.contractorLastname);
        this.spnftForm.get('jmbg').setValue(res.data.contractorJMBG);
        if (res.data.contractorJMBG) {
          if (res.data.contractorJMBG.length >= 7) {
            if (res.data.contractorJMBG.substring(4, 5) == '0') {
              this.spnftForm.get('dob').setValue(res.data.contractorJMBG.substring(0, 2) + "." + res.data.contractorJMBG.substring(2, 4) + '.2' + res.data.contractorJMBG.substring(4, 7))
            } else {
              this.spnftForm.get('dob').setValue(res.data.contractorJMBG.substring(0, 2) + "." + res.data.contractorJMBG.substring(2, 4) + '.1' + res.data.contractorJMBG.substring(4, 7))
            }
          }
        }
        if (res.data.insuredJMBG) {
          if (res.data.insuredJMBG.length >= 7) {
            if (res.data.insuredJMBG.substring(4, 5) == '0') {
              if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + res.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
                this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + res.data.insuredJMBG.substring(4, 7)))
                this.hideExport = false
              }
            } else {
              if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + res.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
                this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + res.data.insuredJMBG.substring(4, 7)))
                this.hideExport = false
              }
            }
          }
        }
        this.spnftForm.get('address').setValue(res.data.contractorAddress);
        this.spnftForm.get('postalCode').setValue(res.data.contractorPostalCode);
        this.spnftForm.get('settlement').setValue(res.data.contractorSettlement);

        this.platimatikForm.get('firstname').setValue(res.data.contractorFirstname);
        this.platimatikForm.get('lastname').setValue(res.data.contractorLastname);
        this.platimatikForm.get('placeOfResidence').setValue(res.data.contractorSettlement);
        this.platimatikForm.get('address').setValue(res.data.contractorAddress);
        this.platimatikForm.get('postalCode').setValue(res.data.contractorPostalCode);
        this.platimatikForm.get('jmbg').setValue(res.data.contractorJMBG)
      }
    )

    this.editSubscription = this.editOfferService.info$.subscribe(
      (res: Number) => {
        // console.log(res)
        if (res == 0) {

        } else {
          this.draftBool = false;
          this.updateDraftModelFull = new StandardOSOffer({ Contractor: new OfferClient(), Insuree: new OfferInsuree(), FATCAQuestionnaire: new FATCAQuestionnaire(), SPNFTForm: new SPNFTQuestionnaire(), PlatimatikForm: new PLATIMATICQuestionnaire() })
          this.offerService.getOne(res)
            .then(
              (x: any) => {
                this.editOfferService.sendOfferID(0)
                console.log(x)

                this.premiumRatePackage = x.premiumRate
                this.sumInsuredPackage = x.sumInsured
                this.deathByAccidentPackage = x.deathByAccident


                this.offerId = x.id;
                this.fillDraftOfferService.sendDraft({ contractor: x.contractor, insuree: x.insuree, contractorIsInsuree: x.contractorIsInsuree })

                this.updateDraftModelFull.data.AppointmentID = x.appointmentID;
                this.updateDraftModelFull.data.Contractor.ID = x.contractor.id;
                this.updateDraftModelFull.data.ContractorID = x.contractor.id;
                this.updateDraftModelFull.data.Insuree.ID = x.insuree.id;
                this.updateDraftModelFull.data.InsureeID = x.insuree.id;
                this.updateDraftModelFull.data.ID = x.id
                this.updateDraftModelFull.data.FATCAQuestionnaire.OfferID = x.id
                this.updateDraftModelFull.data.SPNFTForm.OfferID = x.id
                this.updateDraftModelFull.data.PlatimatikForm.OfferID = x.id
                this.updateDraftModelFull.data.ProductType = 8

                // if (x.additionalPremiumRate == 0) {
                //   this.supplementaryIsnuranceHideAllBool = true;
                // }

                this.insuredSumAndPremiumForm.get('insuranceStart').setValue(x.insuranceStart.split('T')[0].split('-')[2] + "." + x.insuranceStart.split('T')[0].split('-')[1] + "." + x.insuranceStart.split('T')[0].split('-')[0])
                this.insuredSumAndPremiumForm.get('accessAge').setValue(x.startingAge)
                this.insuredSumAndPremiumForm.get('dynamicOfPayment').setValue(x.paymentFrequency)
                this.insuredSumAndPremiumForm.get('currencyPayment').setValue(x.paymentInCurrency || x.paymentInCurrency == 0 ? x.paymentInCurrency.toString() : '')
                this.insuredSumAndPremiumForm.get('currencyPayout').setValue(x.paymentOutCurrency || x.paymentOutCurrency == 0 ? x.paymentOutCurrency.toString() : '')
                this.insuredSumAndPremiumForm.get('indexation').setValue(x.indexation == true ? '1' : x.indexation == false ? '0' : '')
                this.insuredSumAndPremiumForm.get('methodPayment').setValue(x.paymentType || x.paymentType == 0 ? x.paymentType.toString() : '')
                this.changeDate(null)

                this.sendInformations();


                this.insuranceCoverageBool.get('assisstent').setValue(x.additionalAS)
                this.insuranceCoverageBool.get('brokenBone').setValue(x.additionalBF)
                this.insuranceCoverageBool.get('thesisDisease').setValue(x.additionalIL)
                this.changeCheck();


                this.insuranceUsers = [];
                if (x.beneficiaries.length > 0) {
                  for (let i = 0; i < x.beneficiaries.length; i++) {
                    let ob = {
                      OfferID: x.id,
                      Name: x.beneficiaries[i].name,
                      JMBG: x.beneficiaries[i].jmbg,
                      Description: x.beneficiaries[i].description,
                      RoleID: x.beneficiaries[i].roleID,
                      RoleName: x.beneficiaries[i].role.name
                    }
                    this.insuranceUsers.push(ob);
                  }
                }

                if (x.fatcaQuestionnaire) {
                  this.fatcaForm.get('citizenshipSad').setValue(x.fatcaQuestionnaire.q1NP ? '0' : '1')
                  this.fatcaForm.get('texpayerSad').setValue(x.fatcaQuestionnaire.q2NP ? '0' : '1')
                  this.fatcaForm.get('insuredLegalEntitySad').setValue(x.fatcaQuestionnaire.q1LE ? '0' : '1')
                  this.fatcaForm.get('insuredTaxpayerSad').setValue(x.fatcaQuestionnaire.q2LE ? '0' : '1')
                  this.fatcaForm.get('insuredTenPrecentShare').setValue(x.fatcaQuestionnaire.q3LE ? '0' : '1')
                  this.fatcaForm.get('insuredFinancialInstitution').setValue(x.fatcaQuestionnaire.q4LE ? '0' : '1')
                }

                if (x.spnftForm) {
                  this.spnftForm.get('firstname').setValue(x.spnftForm.firstname)
                  this.spnftForm.get('lastname').setValue(x.spnftForm.lastname)
                  this.spnftForm.get('companyName').setValue(x.spnftForm.companyName)
                  this.spnftForm.get('jmbg').setValue(x.spnftForm.jmbg)
                  // this.spnftForm.get('jmbg').setValue(x.spnftForm.jmbg)
                  if (x.spnftForm.jmbg) {
                    this.setSPNFTDate()
                  }
                  this.spnftForm.get('settlementob').setValue(x.spnftForm.placeOfBirth)
                  this.spnftForm.get('address').setValue(x.spnftForm.address)
                  this.spnftForm.get('postalCode').setValue(x.spnftForm.postalCode)
                  this.spnftForm.get('settlement').setValue(x.spnftForm.settlement)
                  this.spnftForm.get('citizenship').setValue(x.spnftForm.citizenship)
                  this.spnftForm.get('legalRepresentativeFirstname').setValue(x.spnftForm.legalRepresentativeFirtsname ? x.spnftForm.legalRepresentativeFirtsname : '')
                  this.spnftForm.get('legalRepresentativeLastname').setValue(x.spnftForm.legalRepresentativeLastname ? x.spnftForm.legalRepresentativeLastname : '')
                  this.spnftForm.get('representativeJmbg').setValue(x.spnftForm.legalRepresentativeJMBG ? x.spnftForm.legalRepresentativeJMBG : '')
                  this.spnftForm.get('pib').setValue(x.spnftForm.taxID ? x.spnftForm.taxID : '')
                  this.spnftForm.get('mb').setValue(x.spnftForm.companyID ? x.spnftForm.companyID : '')
                  this.spnftForm.get('numberOfDocument').setValue(x.spnftForm.personalDocumentNumber ? x.spnftForm.personalDocumentNumber : '')
                  this.spnftForm.get('numberOfDocument').setValue(x.spnftForm.personalDocumentNumber)
                  this.spnftForm.get('typeOfDocument').setValue(x.spnftForm.personalDocumentType || x.spnftForm.personalDocumentType == 0 ? x.spnftForm.personalDocumentType.toString() : '')
                  // if (x.spnftForm.personalDocumentIssuedDate)
                  // console.log(x.spnftForm.personalDocumentIssuedDate)
                  // console.log(x.spnftForm.personalDocumentIssuedDate ? x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[2] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[1] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[0] : '')
                  this.spnftForm.get('dateOfIssuringDocument').setValue(x.spnftForm.personalDocumentIssuedDate ? x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[2] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[1] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[0] : '')
                  this.spnftForm.get('personalDocumentExpirationDate').setValue(x.spnftForm.personalDocumentExpirationDate ? x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[2] + "." + x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[1] + "." + x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[0] : '')
                  this.spnftForm.get('placeOfIssuringDocument').setValue(x.spnftForm.personalDocumentIssuedPlace)

                  this.spnftForm.get('officialCloseFamily').setValue(x.spnftForm.isPoliticianOrCloseAssociate ? '1' : '0')
                  this.spnftForm.get('closeFamilyName').setValue(x.spnftForm.inOffice)
                  this.spnftForm.get('officialPeriod').setValue(x.spnftForm.remarkIfYes)

                  this.spnftForm.get('cutomerAnotherPerson').setValue(x.spnftForm.clientAppliesThroughIntermediary ? '1' : '0')
                  this.spnftForm.get('cutomerAnotherPersonRole').setValue(x.spnftForm.intermediaryType || x.spnftForm.intermediaryType == 0 ? x.spnftForm.intermediaryType.toString() : '')
                  this.spnftForm.get('firstnameOnBehalf').setValue(x.spnftForm.intermediaryFirstname)
                  this.spnftForm.get('lastnameOnBehalf').setValue(x.spnftForm.intermediaryLastname)
                  this.spnftForm.get('settlementobOnBehalf').setValue(x.spnftForm.intermediaryPlaceOfBirth)
                  this.spnftForm.get('jmbgOnBehalf').setValue(x.spnftForm.intermediaryJMBG)
                  // if (x.spnftForm.personalDocumentIssuedDate)
                  this.spnftForm.get('dobOnBehalf').setValue(x.spnftForm.intermediaryDateOfBirth ? formatDate(x.spnftForm.intermediaryDateOfBirth, 'dd.MM.yyyy', 'en') : '')
                  this.spnftForm.get('addressOnBehalf').setValue(x.spnftForm.intermediaryAddress)
                  this.spnftForm.get('postalCodeOnBehalf').setValue(x.spnftForm.intermediaryPostalCode)
                  this.spnftForm.get('settlementOnBehalf').setValue(x.spnftForm.intermediarySettlement)
                  this.spnftForm.get('idNumberOnBehalf').setValue(x.spnftForm.intermediaryPersonalDocumentNumber)
                  this.spnftForm.get('idTypeOnBehalf').setValue(x.spnftForm.intermediaryPersonalDocumentType || x.spnftForm.intermediaryPersonalDocumentType == 0 ? x.spnftForm.intermediaryPersonalDocumentType : '')
                  // if (x.spnftForm.intermediaryPersonalDocumentIssuedDate)
                  this.spnftForm.get('idDate').setValue(x.spnftForm.intermediaryPersonalDocumentIssuedDate ? formatDate(x.spnftForm.intermediaryPersonalDocumentIssuedDate, 'dd.MM.yyyy', 'en') : '')
                  this.spnftForm.get('idPlace').setValue(x.spnftForm.intermediaryPersonalDocumentIssuedPlace)
                  if (x.spnftForm.businessRelationshipClientPurpose)
                    this.spnftForm.get('purposeOfBusinessRelation').setValue(x.spnftForm.businessRelationshipClientPurpose || x.spnftForm.businessRelationshipClientPurpose == 0 ? x.spnftForm.businessRelationshipClientPurpose.toString() : '')
                  this.spnftForm.get('purposeOfBusinessRelationOther').setValue(x.spnftForm.businessRelationshipClientPurposeOther)
                  this.spnftForm.get('originOfProperty').setValue(x.spnftForm.propertyOrigin || x.spnftForm.propertyOrigin == 0 ? x.spnftForm.propertyOrigin.toString() : '')
                  this.spnftForm.get('originOfPropertyOther').setValue(x.spnftForm.propertyOriginOther)
                }

                if (x.platimatikForm) {
                  this.platimatikForm.get('firstname').setValue(x.platimatikForm.firstname)
                  this.platimatikForm.get('lastname').setValue(x.platimatikForm.lastname)
                  this.platimatikForm.get('address').setValue(x.platimatikForm.address)
                  this.platimatikForm.get('postalCode').setValue(x.platimatikForm.postalCode)
                  this.platimatikForm.get('placeOfResidence').setValue(x.platimatikForm.settlement)
                  this.platimatikForm.get('jmbg').setValue(x.platimatikForm.jmbg)
                  this.platimatikForm.get('firstThreeAccountNumber').setValue(x.platimatikForm.accountNumber.substring(0, 3))
                  this.platimatikForm.get('middleAccountNumber').setValue(x.platimatikForm.accountNumber.substring(3, 16))
                  this.platimatikForm.get('lastTwoAccountNumber').setValue(x.platimatikForm.accountNumber.substring(16, 18))
                  this.platimatikForm.get('bankName').setValue(x.platimatikForm.bank)
                  this.platimatikForm.get('bankBic').setValue(x.platimatikForm.bic)
                  this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(30 + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
                  this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(30 + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
                }

                this.checkBoxesForm.get('confirmVeracity').setValue(x.verified)
                this.checkBoxesForm.get('confirmData').setValue(x.verified2)
                this.checkBoxesForm.get('confirmSMS').setValue(x.notificationsAgreement ? '1' : '0')
                this.checkBoxesForm.get('confirmEmail').setValue(x.verified3 ? '1' : '0')


              }
            )
        }
      }
    )

  }

  ngOnInit() {
    this.getRoles(8);
    this.getUser()
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'));
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.todayDate.getFullYear() + 30, this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.todayDate.getFullYear() + 30, this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
  }

  ngOnDestroy() {
    this.roleService.unsubscribe();
    this.basicInfoSubscription.unsubscribe();
    this.editSubscription.unsubscribe();
  }

  todayDate = new Date();
  changeDate(change: Boolean) {
    if (change == true) {
      this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    } else if (change == false) {
      this.todayDate.setMonth(this.todayDate.getMonth() - 1);
    }
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'))

    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))

    this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.todayDate.getFullYear() + 30, this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.todayDate.getFullYear() + 30, this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))

    if (this.basicInfo.data.insuredJMBG) {
      if (this.basicInfo.data.insuredJMBG.length >= 7) {
        if (this.basicInfo.data.insuredJMBG.substring(4, 5) == '0') {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        } else {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        }
      }
    }

  }

  changePackage(num: number) {
    this.selectedPackage = num;
    if (this.calculationDone) {
      let calc = this.PremiumRate[this.selectedPackage - 1];
      if (this.insuranceCoverageBool.value.thesisDisease) {
        calc += this.AdditionalPremiumRateIllness[this.selectedPackage - 1];
      }
      if (this.insuranceCoverageBool.value.brokenBone) {
        calc += this.AdditionalPremiumRateBoneFracture[this.selectedPackage - 1];
      }
      if (this.insuranceCoverageBool.value.assisstent) {
        calc += this.AdditionalPremiumRateAssistance[this.selectedPackage - 1];
      }
      this.insuranceSumForm.get('sumPremiumRate').setValue(calc.toFixed(2));
      this.insuranceSumForm.get('sumYearly').setValue((calc * parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment)).toFixed(2));
    } else {

    }
  }

  changeCheck() {
    if (this.calculationDone) {
      let calc = this.PremiumRate[this.selectedPackage - 1];
      if (this.insuranceCoverageBool.value.thesisDisease) {
        calc += this.AdditionalPremiumRateIllness[this.selectedPackage - 1];
      }
      if (this.insuranceCoverageBool.value.brokenBone) {
        calc += this.AdditionalPremiumRateBoneFracture[this.selectedPackage - 1];
      }
      if (this.insuranceCoverageBool.value.assisstent) {
        calc += this.AdditionalPremiumRateAssistance[this.selectedPackage - 1];
      }
      this.insuranceSumForm.get('sumPremiumRate').setValue(calc.toFixed(2));
      this.insuranceSumForm.get('sumYearly').setValue((calc.toFixed(2) * parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment)).toFixed(2));
    } else {

    }
  }

  PremiumRate = [];
  AdditionalPremiumRateIllness = [];
  AdditionalPremiumRateBoneFracture = [];
  AdditionalPremiumRateAssistance = [];
  sendInformations() {
    if (this.insuredSumAndPremiumForm.value.accessAge && this.insuredSumAndPremiumForm.value.dynamicOfPayment) {
      let goldenAutumn = new GoldenAutumn({ RateTable: null, Age: this.insuredSumAndPremiumForm.value.accessAge, PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment) })

      console.log(goldenAutumn)
      if (
        this.insuredSumAndPremiumForm.value.accessAge < 40 ||
        this.insuredSumAndPremiumForm.value.accessAge > 80
      ) {
        this.errorTitle = "Podaci nisu ispravni";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.calculatorStandard.calculateGoldenAutumn(goldenAutumn)
          .subscribe(
            (x: any) => {
              console.log(x);
              this.hideExport = true;
              this.sentInformation = x;

              if (!this.draftBool) {
                for (let i = 0; i < 6; i++) {
                  if (x.premiumRate[i] == this.premiumRatePackage && x.sumInsuredDeath[i] == this.sumInsuredPackage && x.sumInsuredDeathByAccident[i] == this.deathByAccidentPackage) {
                    this.selectedPackage = i + 1;
                  }
                }
              }

              this.PremiumRate = x.premiumRate;
              this.AdditionalPremiumRateIllness = x.additionalPremiumRateIllness;
              this.AdditionalPremiumRateBoneFracture = x.additionalPremiumRateBoneFracture;
              this.AdditionalPremiumRateAssistance = x.additionalPremiumRateAssistance;

              this.calculationDone = true;
              this.packegeOnePremiumRate = x.premiumRate[0]
              this.packegeTwoPremiumRate = x.premiumRate[1]
              this.packegeThreePremiumRate = x.premiumRate[2]
              this.packegeFourPremiumRate = x.premiumRate[3]
              this.packegeFivePremiumRate = x.premiumRate[4]
              this.packegeSixPremiumRate = x.premiumRate[5]

              this.packegeOneInsuranceSum = x.sumInsuredDeath[0]
              this.packegeTwoInsuranceSum = x.sumInsuredDeath[1]
              this.packegeThreeInsuranceSum = x.sumInsuredDeath[2]
              this.packegeFourInsuranceSum = x.sumInsuredDeath[3]
              this.packegeFiveInsuranceSum = x.sumInsuredDeath[4]
              this.packegeSixInsuranceSum = x.sumInsuredDeath[5]

              this.packegeOneInsuranceSumDeath = x.sumInsuredDeathByAccident[0]
              this.packegeTwoInsuranceSumDeath = x.sumInsuredDeathByAccident[1]
              this.packegeThreeInsuranceSumDeath = x.sumInsuredDeathByAccident[2]
              this.packegeFourInsuranceSumDeath = x.sumInsuredDeathByAccident[3]
              this.packegeFiveInsuranceSumDeath = x.sumInsuredDeathByAccident[4]
              this.packegeSixInsuranceSumDeath = x.sumInsuredDeathByAccident[5]

              this.packageOneThesisDiseaseFirst = x.additionalPremiumRateIllness[0].toFixed(2)
              this.packageTwoThesisDiseaseFirst = x.additionalPremiumRateIllness[1].toFixed(2)
              this.packageThreeThesisDiseaseFirst = x.additionalPremiumRateIllness[2].toFixed(2)
              this.packageFourThesisDiseaseFirst = x.additionalPremiumRateIllness[3].toFixed(2)
              this.packageFiveThesisDiseaseFirst = x.additionalPremiumRateIllness[4].toFixed(2)
              this.packageSixThesisDiseaseFirst = x.additionalPremiumRateIllness[5].toFixed(2)

              this.packageOneThesisDiseaseSecond = x.additionalSumInsuredIllness[0]
              this.packageTwoThesisDiseaseSecond = x.additionalSumInsuredIllness[1]
              this.packageThreeThesisDiseaseSecond = x.additionalSumInsuredIllness[2]
              this.packageFourThesisDiseaseSecond = x.additionalSumInsuredIllness[3]
              this.packageFiveThesisDiseaseSecond = x.additionalSumInsuredIllness[4]
              this.packageSixThesisDiseaseSecond = x.additionalSumInsuredIllness[5]

              this.packageOneBrokenBonesFirst = x.additionalPremiumRateBoneFracture[0].toFixed(2)
              this.packageTwoBrokenBonesFirst = x.additionalPremiumRateBoneFracture[1].toFixed(2)
              this.packageThreeBrokenBonesFirst = x.additionalPremiumRateBoneFracture[2].toFixed(2)
              this.packageFourBrokenBonesFirst = x.additionalPremiumRateBoneFracture[3].toFixed(2)
              this.packageFiveBrokenBonesFirst = x.additionalPremiumRateBoneFracture[4].toFixed(2)
              this.packageSixBrokenBonesFirst = x.additionalPremiumRateBoneFracture[5].toFixed(2)

              this.packageOneBrokenBonesSecond = x.additionalSumInsuredBoneFracture[0];
              this.packageTwoBrokenBonesSecond = x.additionalSumInsuredBoneFracture[1];
              this.packageThreeBrokenBonesSecond = x.additionalSumInsuredBoneFracture[2];
              this.packageFourBrokenBonesSecond = x.additionalSumInsuredBoneFracture[3];
              this.packageFiveBrokenBonesSecond = x.additionalSumInsuredBoneFracture[4];
              this.packageSixBrokenBonesSecond = x.additionalSumInsuredBoneFracture[5];

              this.packageOneAssisstent = x.additionalPremiumRateAssistance[0];
              this.packageTwoAssisstent = x.additionalPremiumRateAssistance[1];
              this.packageThreeAssisstent = x.additionalPremiumRateAssistance[2];
              this.packageFourAssisstent = x.additionalPremiumRateAssistance[3];
              this.packageFiveAssisstent = x.additionalPremiumRateAssistance[4];
              this.packageSixAssisstent = x.additionalPremiumRateAssistance[5];


              let calc = this.PremiumRate[this.selectedPackage - 1];
              if (this.insuranceCoverageBool.value.thesisDisease) {
                calc += this.AdditionalPremiumRateIllness[this.selectedPackage - 1];
              }
              if (this.insuranceCoverageBool.value.brokenBone) {
                calc += this.AdditionalPremiumRateBoneFracture[this.selectedPackage - 1];
              }
              if (this.insuranceCoverageBool.value.assisstent) {
                calc += this.AdditionalPremiumRateAssistance[this.selectedPackage - 1];
              }
              this.insuranceSumForm.get('sumPremiumRate').setValue(calc.toFixed(2));
              this.insuranceSumForm.get('sumYearly').setValue((calc.toFixed(2) * parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment)).toFixed(2));

            },
            (x: { error: String }) => {
              console.log(x)
              this.errorTitle = x.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      }
    } else {
      this.errorTitle = "Niste uneli sve tražene podatke";
      this.modalService.open(this.alertModal, { centered: true })

    }
  }

  exportpft() {
    let startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
    let exportpdf = new GoldenAutumnExport({
      ContratcorType: this.basicInfo.data.contractorType == '1' ? '1' : '0',
      CompanyName: this.basicInfo.data.contractorResponsibleName,
      Firstname: this.basicInfo.data.contractorFirstname,
      Lastname: this.basicInfo.data.contractorLastname,
      JMBG: this.basicInfo.data.contractorJMBG,
      Email: this.basicInfo.data.contractorEmail,
      TaxID: this.basicInfo.data.contractorPIB,
      CompanyID: this.basicInfo.data.contractorID,
      Address: this.basicInfo.data.contractorAddress,
      Settlement: this.basicInfo.data.contractorSettlement,
      PostalCode: this.basicInfo.data.contractorPostalCode,
      ContactPhone: this.basicInfo.data.contractorPhonenumber,
      DeliveryAddress: this.basicInfo.data.contractorAddressOfDelivery,
      InsureeFirstname: this.basicInfo.data.insuredFirstname,
      InsureeLastname: this.basicInfo.data.insuredLastname,
      InsureeAddress: this.basicInfo.data.insuredAddress,
      InsureeSettlement: this.basicInfo.data.insuredSettlement,
      InsureePostalCode: this.basicInfo.data.insuredPostalCode,
      InsureeJMBG: this.basicInfo.data.insuredJMBG,
      InsureeContactPhone1: this.basicInfo.data.insuredMobile,
      InsureeContactPhone2: '',
      InsureeOccupation: '',
      StartTime: startDate,
      EndTime: '0001-01-01',
      Duration: 0,
      Age: this.insuredSumAndPremiumForm.value.accessAge,
      Gender: '',
      HazardLevel: 0,
      CigarettesPerDay: 0,
      PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment),
      Height: 0,
      Weight: 0,
      Offer: this.insuredSumAndPremiumForm.value.offer,
      RedemptionAndCapitalization: false,
      ProContract: this.insuredSumAndPremiumForm.value.proContract,
      Terms: this.insuredSumAndPremiumForm.value.terms,
      AdditionalInsurance: !this.supplementaryIsnuranceHideAllBool,
      AdditionalDocumentation: false,
      AdditionalIL: this.insuranceCoverageBool.value.thesisDisease,
      AdditionalBF: this.insuranceCoverageBool.value.brokenBone,
      AdditionalAS: this.insuranceCoverageBool.value.assisstent
    });
    switch (this.selectedPackage) {
      case 1:
        exportpdf.data.SelectedPackage = 0
        exportpdf.data.PremiumRate = this.sentInformation.premiumRate[0];
        exportpdf.data.SumInsuredDeath = this.sentInformation.sumInsuredDeath[0];
        exportpdf.data.SumInsuredDeathByAccident = this.sentInformation.sumInsuredDeathByAccident[0];
        exportpdf.data.AdditionalPremiumRateIllness = this.sentInformation.additionalPremiumRateIllness[0];
        exportpdf.data.AdditionalSumInsuredIllness = this.sentInformation.additionalSumInsuredIllness[0];
        exportpdf.data.AdditionalPremiumRateBoneFracture = this.sentInformation.additionalPremiumRateBoneFracture[0];
        exportpdf.data.AdditionalSumInsuredBoneFracture = this.sentInformation.additionalSumInsuredBoneFracture[0];
        exportpdf.data.AdditionalPremiumRateAssistance = this.sentInformation.additionalPremiumRateAssistance[0];
        break;
      case 2:
        exportpdf.data.PremiumRate = this.sentInformation.premiumRate[1];
        exportpdf.data.SumInsuredDeath = this.sentInformation.sumInsuredDeath[1];
        exportpdf.data.SumInsuredDeathByAccident = this.sentInformation.sumInsuredDeathByAccident[1];
        exportpdf.data.AdditionalPremiumRateIllness = this.sentInformation.additionalPremiumRateIllness[1];
        exportpdf.data.AdditionalSumInsuredIllness = this.sentInformation.additionalSumInsuredIllness[1];
        exportpdf.data.AdditionalPremiumRateBoneFracture = this.sentInformation.additionalPremiumRateBoneFracture[1];
        exportpdf.data.AdditionalSumInsuredBoneFracture = this.sentInformation.additionalSumInsuredBoneFracture[1];
        exportpdf.data.AdditionalPremiumRateAssistance = this.sentInformation.additionalPremiumRateAssistance[1];
        exportpdf.data.SelectedPackage = 1
        break;
      case 3:
        exportpdf.data.PremiumRate = this.sentInformation.premiumRate[2];
        exportpdf.data.SumInsuredDeath = this.sentInformation.sumInsuredDeath[2];
        exportpdf.data.SumInsuredDeathByAccident = this.sentInformation.sumInsuredDeathByAccident[2];
        exportpdf.data.AdditionalPremiumRateIllness = this.sentInformation.additionalPremiumRateIllness[2];
        exportpdf.data.AdditionalSumInsuredIllness = this.sentInformation.additionalSumInsuredIllness[2];
        exportpdf.data.AdditionalPremiumRateBoneFracture = this.sentInformation.additionalPremiumRateBoneFracture[2];
        exportpdf.data.AdditionalSumInsuredBoneFracture = this.sentInformation.additionalSumInsuredBoneFracture[2];
        exportpdf.data.AdditionalPremiumRateAssistance = this.sentInformation.additionalPremiumRateAssistance[2];
        exportpdf.data.SelectedPackage = 2
        break;
      case 4:
        exportpdf.data.PremiumRate = this.sentInformation.premiumRate[3];
        exportpdf.data.SumInsuredDeath = this.sentInformation.sumInsuredDeath[3];
        exportpdf.data.SumInsuredDeathByAccident = this.sentInformation.sumInsuredDeathByAccident[3];
        exportpdf.data.AdditionalPremiumRateIllness = this.sentInformation.additionalPremiumRateIllness[3];
        exportpdf.data.AdditionalSumInsuredIllness = this.sentInformation.additionalSumInsuredIllness[3];
        exportpdf.data.AdditionalPremiumRateBoneFracture = this.sentInformation.additionalPremiumRateBoneFracture[3];
        exportpdf.data.AdditionalSumInsuredBoneFracture = this.sentInformation.additionalSumInsuredBoneFracture[3];
        exportpdf.data.AdditionalPremiumRateAssistance = this.sentInformation.additionalPremiumRateAssistance[3];
        exportpdf.data.SelectedPackage = 3
        break;
      case 5:
        exportpdf.data.PremiumRate = this.sentInformation.premiumRate[4];
        exportpdf.data.SumInsuredDeath = this.sentInformation.sumInsuredDeath[4];
        exportpdf.data.SumInsuredDeathByAccident = this.sentInformation.sumInsuredDeathByAccident[4];
        exportpdf.data.AdditionalPremiumRateIllness = this.sentInformation.additionalPremiumRateIllness[4];
        exportpdf.data.AdditionalSumInsuredIllness = this.sentInformation.additionalSumInsuredIllness[4];
        exportpdf.data.AdditionalPremiumRateBoneFracture = this.sentInformation.additionalPremiumRateBoneFracture[4];
        exportpdf.data.AdditionalSumInsuredBoneFracture = this.sentInformation.additionalSumInsuredBoneFracture[4];
        exportpdf.data.AdditionalPremiumRateAssistance = this.sentInformation.additionalPremiumRateAssistance[4];
        exportpdf.data.SelectedPackage = 4
        break;
      case 6:
        exportpdf.data.PremiumRate = this.sentInformation.premiumRate[5];
        exportpdf.data.SumInsuredDeath = this.sentInformation.sumInsuredDeath[5];
        exportpdf.data.SumInsuredDeathByAccident = this.sentInformation.sumInsuredDeathByAccident[5];
        exportpdf.data.AdditionalPremiumRateIllness = this.sentInformation.additionalPremiumRateIllness[5];
        exportpdf.data.AdditionalSumInsuredIllness = this.sentInformation.additionalSumInsuredIllness[5];
        exportpdf.data.AdditionalPremiumRateBoneFracture = this.sentInformation.additionalPremiumRateBoneFracture[5];
        exportpdf.data.AdditionalSumInsuredBoneFracture = this.sentInformation.additionalSumInsuredBoneFracture[5];
        exportpdf.data.AdditionalPremiumRateAssistance = this.sentInformation.additionalPremiumRateAssistance[5];
        exportpdf.data.SelectedPackage = 5
        break;
      default:
        break;
    }
    let calc = this.sentInformation.premiumRate[this.selectedPackage - 1];
    if (this.insuranceCoverageBool.value.thesisDisease) {
      calc += this.sentInformation.additionalPremiumRateIllness[this.selectedPackage - 1];
    }
    if (this.insuranceCoverageBool.value.brokenBone) {
      calc += this.sentInformation.additionalPremiumRateBoneFracture[this.selectedPackage - 1];
    }
    if (this.insuranceCoverageBool.value.assisstent) {
      calc += this.sentInformation.additionalPremiumRateAssistance[this.selectedPackage - 1];
    }
    exportpdf.data.TotalPremiumRateInstalment = calc;
    exportpdf.data.TotalPremiumRateYearly = calc * parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment);
    console.log(exportpdf);
    this.exportService.exportGoldenAutumn(exportpdf)
      .subscribe(
        x => {
          console.log(x);
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1].split('"')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      )
  }

  resetAllForms() {
    this.insuredSumAndPremiumForm.reset({ currencyPayment: '0', currencyPayout: '0', insuranceEnd: 'DOŽIVOTNO', dynamicOfPayment: '12', terms: false, proContract: false, offer: true })
    this.todayDate = new Date()
    this.todayDate.setDate(1);
    this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.healthForm.reset()
    this.insuranceSumForm.reset({ sumPremiumRate: '', sumYearly: '' });
    this.fatcaForm.reset({
      citizenshipSad: '1',
      texpayerSad: '1',
      insuredLegalEntitySad: '1',
      insuredTaxpayerSad: '1',
      insuredTenPrecentShare: '1',
      insuredFinancialInstitution: '1'
    })
    this.packegeOnePremiumRate = null;
    this.packegeOneInsuranceSum = null;
    this.packegeOneInsuranceSumDeath = null;
    this.packegeTwoPremiumRate = null;
    this.packegeTwoInsuranceSum = null;
    this.packegeTwoInsuranceSumDeath = null;
    this.packegeThreePremiumRate = null;
    this.packegeThreeInsuranceSum = null;
    this.packegeThreeInsuranceSumDeath = null;
    this.packegeFourPremiumRate = null;
    this.packegeFourInsuranceSum = null;
    this.packegeFourInsuranceSumDeath = null;
    this.packegeFivePremiumRate = null;
    this.packegeFiveInsuranceSum = null;
    this.packegeFiveInsuranceSumDeath = null;
    this.packegeSixPremiumRate = null;
    this.packegeSixInsuranceSum = null;
    this.packegeSixInsuranceSumDeath = null;

    this.packageOneThesisDiseaseFirst = null;
    this.packageOneThesisDiseaseSecond = null;
    this.packageOneBrokenBonesFirst = null;
    this.packageOneBrokenBonesSecond = null;
    this.packageOneAssisstent = null;
    this.packageTwoThesisDiseaseFirst = null;
    this.packageTwoThesisDiseaseSecond = null;
    this.packageTwoBrokenBonesFirst = null;
    this.packageTwoBrokenBonesSecond = null;
    this.packageTwoAssisstent = null;
    this.packageThreeThesisDiseaseFirst = null;
    this.packageThreeThesisDiseaseSecond = null;
    this.packageThreeBrokenBonesFirst = null;
    this.packageThreeBrokenBonesSecond = null;
    this.packageThreeAssisstent = null;
    this.packageFourThesisDiseaseFirst = null;
    this.packageFourThesisDiseaseSecond = null;
    this.packageFourBrokenBonesFirst = null;
    this.packageFourBrokenBonesSecond = null;
    this.packageFourAssisstent = null;
    this.packageFiveThesisDiseaseFirst = null;
    this.packageFiveThesisDiseaseSecond = null;
    this.packageFiveBrokenBonesFirst = null;
    this.packageFiveBrokenBonesSecond = null;
    this.packageFiveAssisstent = null;
    this.packageSixThesisDiseaseFirst = null;
    this.packageSixThesisDiseaseSecond = null;
    this.packageSixBrokenBonesFirst = null;
    this.packageSixBrokenBonesSecond = null;
    this.packageSixAssisstent = null;
    this.spnftForm.reset({ officialCloseFamily: '0' })
    this.sendInfoService.sendInfo(true)
    this.platimatikForm.reset()
    this.hideExport = false;
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.checkBoxesForm.reset({ confirmVeracity: false, confirmData: false, confirmSMS: '1', confirmEmail: '1' })
    this.insuranceUsers = []
    this.validInsuranceAndSumPremium = false;
    this.validUser = false;
    this.validSPNFT = true;
    this.validPLATIMATIK = false;
    this.calculcatorUsersBool = false;
    this.noticePersonalityBool = false;
    this.noticeFatcaBool = false;
    this.formSpnftBool = false;
    // this.basicInfo = new BasicInformations({});
  }

  addInsuranceUser() {
    let num = 0;
    for (let i = 0; i < this.insuranceUsers.length; i++) {
      if (parseInt(this.insuranceUserForm.value.role.split('-')[0]) == this.insuranceUsers[i].RoleID) {
        num++;
      }
    }
    if (parseInt(this.insuranceUserForm.value.role.split('-')[2]) == 0) {
      if (num >= 1) {
        this.errorTitle = "Ne mozete uneti više korisnika sa tom rolom";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.insuranceUsers.push(new Beneficiaries(0, this.insuranceUserForm.value.name.toUpperCase(), this.insuranceUserForm.value.jmbg, this.insuranceUserForm.value.remark, parseInt(this.insuranceUserForm.value.role.split('-')[0]), this.insuranceUserForm.value.role.split('-')[1], 0))
      }
    } else {
      if (num >= parseInt(this.insuranceUserForm.value.role.split('-')[2])) {
        this.errorTitle = "Ne mozete uneti više korisnika sa tom rolom";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.insuranceUsers.push(new Beneficiaries(0, this.insuranceUserForm.value.name.toUpperCase(), this.insuranceUserForm.value.jmbg, this.insuranceUserForm.value.remark, parseInt(this.insuranceUserForm.value.role.split('-')[0]), this.insuranceUserForm.value.role.split('-')[1], 0))
      }
    }
    this.insuranceUserForm.reset();
  }
  removeFromList(i) {
    this.insuranceUsers.splice(i, 1);
  }

  accountNumberSetBank() {
    if (this.platimatikForm.value.firstThreeAccountNumber.length == 3) {
      this.bankService.gridView(new Filter({ Top: null, Page: null, Filter: {}, Sort: {} }))
        .subscribe(
          (res: Array<{ code: String, name: String, swift: String }>) => {
            for (let i = 0; i < res.length; i++) {
              if (res[i].code == this.platimatikForm.value.firstThreeAccountNumber) {
                this.platimatikForm.get('bankName').setValue(res[i].name);
                this.platimatikForm.get('bankBic').setValue(res[i].swift);
                this.accNumber.nativeElement.focus();
                break;
              }
            }
          }
        )
    } else if (this.platimatikForm.value.firstThreeAccountNumber.length < 3) {
      this.platimatikForm.get('bankName').setValue('');
      this.platimatikForm.get('bankBic').setValue('');
    }
  }

  checkAccount() {
    if (this.platimatikForm.value.middleAccountNumber.length <= 13) {
      this.platimatikForm.get('middleAccountNumber').setValue('0'.repeat(13 - this.platimatikForm.value.middleAccountNumber.length) + this.platimatikForm.value.middleAccountNumber)
    }
  }

  signOnSpot(DBool) {
    // console.log(this.offerId);
    if (DBool) {
      this.offerService.createDigitalOffer(this.offerModelFull)
        .then(
          (x: any) => {
            console.log(x);
            this.offerId = x;
            this.offerService.sendLocalDocuments(this.offerId)
              .then(
                x => {
                  this.modalService.dismissAll();
                  this.resetAllForms()
                  this.insuranceUsers = []
                  this.formPlatimatikBool = false;
                  this.formSpnftBool = false;
                  this.noticeFatcaBool = false;
                  this.healthQuestionnaireBool = false;
                  this.calculcatorUsersBool = false;
                  this.validInsuranceAndSumPremium = false;
                  this.validUser = false;
                  this.validSPNFT = false;
                  this.validPLATIMATIK = false;
                  this.router.navigate(['/sign-documents-on-spot/' + this.offerId]);
                  // this.router.navigate([]).then(r => { window.open('/sign-documents-on-spot/' + this.offerId, '_blank') })
                }
              )
          },
          (x: any) => {
            console.log(x)
            this.errorTitle = x.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else {
      this.updateDraft(2);
    }
  }

  openSignOnDistanceModal(modal) {
    this.modalService.open(modal, { size: 'lg', backdrop: 'static', keyboard: false })
  }
  openSignOnSiteModal(modal) {
    this.modalService.open(modal, { size: 'lg', backdrop: 'static', keyboard: false })
  }
  blockSendingBool: boolean = true
  openRiskModal(modal, DBool) {
    if (DBool) {
      this.blockSendingBool = false
      this.offerService.createDigitalOffer(this.offerModelFull)
        .then(
          (x: any) => {
            console.log(x);
            this.blockSendingBool = true
            this.offerId = x;
            this.riskAssessmentForm.reset();
            this.modalService.open(modal, { size: 'xl', backdrop: 'static', keyboard: false })
            if (this.spnftForm.value.officialCloseFamily == '1') {
              this.riskAssessmentForm.get('question11').setValue('0');
              this.riskAssessmentForm.get('question11').disable();
            } else {
              this.riskAssessmentForm.get('question11').enable();
            }
          },
          (x: any) => {
            console.log(x)
            this.errorTitle = x.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else {
      this.updateDraft(1);
    }
  }
  addRiskAssessment() {
    if (this.riskAssessmentForm.valid) {
      let risk = new RiskAssessment({
        OfferID: this.offerId,
        Q1: this.riskAssessmentForm.value.question1 == '0' ? true : false,
        Q2: this.riskAssessmentForm.value.question2 == '0' ? true : false,
        Q3: this.riskAssessmentForm.value.question3 == '0' ? true : false,
        Q4: this.riskAssessmentForm.value.question4 == '0' ? true : false,
        Q5: this.riskAssessmentForm.value.question5 == '0' ? true : false,
        Q6: this.riskAssessmentForm.value.question6 == '0' ? true : false,
        Q7: this.riskAssessmentForm.value.question7 == '0' ? true : false,
        Q8: this.riskAssessmentForm.value.question8 == '0' ? true : false,
        Q9: this.riskAssessmentForm.value.question9 == '0' ? true : false,
        Q10: this.riskAssessmentForm.value.question10 == '0' ? true : false,
        Q11: this.riskAssessmentForm.get('question11').value == '0' ? true : false,
        Q12: this.riskAssessmentForm.value.question12 == '0' ? true : false,
        Q13: this.riskAssessmentForm.value.question13 == '0' ? true : false,
        Q14: this.riskAssessmentForm.value.question14 == '0' ? true : false,
        Q15: this.riskAssessmentForm.value.question15 == '0' ? true : false,
        Q16: this.riskAssessmentForm.value.question16 == '0' ? true : false,
        Q17: this.riskAssessmentForm.value.question17 == '0' ? true : false,
        Q18: this.riskAssessmentForm.value.question18 == '0' ? true : false,
        Q19: this.riskAssessmentForm.value.question19 == '0' ? true : false,
        Q20: this.riskAssessmentForm.value.question20 == '0' ? true : false,
        Q21: this.riskAssessmentForm.value.question21 == '0' ? true : false,
        Q22: this.riskAssessmentForm.value.question22 == '0' ? true : false,
        Q23: this.riskAssessmentForm.value.question23 == '0' ? true : false,
        Q24: this.riskAssessmentForm.value.question24 == '0' ? true : false,
        Q25: this.riskAssessmentForm.value.question25 == '0' ? true : false,
        Q26: this.riskAssessmentForm.value.question26 == '0' ? true : false,
        Q27: this.riskAssessmentForm.value.question27 == '0' ? true : false,
        Q28: this.riskAssessmentForm.value.question28 == '0' ? true : false,
        Q29: this.riskAssessmentForm.value.question29 == '0' ? true : false,
        UnableToGetData: false
      })
      this.offerService.createRiskAssessment(risk)
        .then(
          x => {
            // this.modalService.dismissAll();
            this.signDistance();
            // this.modalService.open(modal, { size: 'lg', backdrop: 'static', keyboard: false })
          }
        )
    } else {
      // console.log("now checked wverything")
      this.errorTitle = "Niste odgovorili na sva pitanja";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }
  signDistance() {
    console.log(this.offerId);
    this.offerService.sentSignRequest(this.offerId)
      .then(
        x => {
          console.log(x);
          this.successTitle = "Uspešno ste kreirali digitalnu ponudu";
          this.modalService.dismissAll();
          this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
          this.resetAllForms()
          this.insuranceUsers = []
          this.formPlatimatikBool = false;
          this.formSpnftBool = false;
          this.noticeFatcaBool = false;
          this.healthQuestionnaireBool = false;
          this.calculcatorUsersBool = false;
          this.validInsuranceAndSumPremium = false;
          this.validUser = false;
          this.validSPNFT = false;
          this.validPLATIMATIK = false;
          this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
        }
      )
  }

  draftModelFull: StandardOSOffer;
  saveDraft() {
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname) {
        this.saveDraftService.addInfo();
        console.log("Nije uneto ime i prezime")
      } else {
        if (
          this.sentInformation.premiumRate[this.selectedPackage - 1] == 12.9 &&
          ((this.insuranceCoverageBool.value.thesisDisease && !this.insuranceCoverageBool.value.brokenBone && !this.insuranceCoverageBool.value.assisstent) || (!this.insuranceCoverageBool.value.thesisDisease && this.insuranceCoverageBool.value.brokenBone && !this.insuranceCoverageBool.value.assisstent) || (!this.insuranceCoverageBool.value.thesisDisease && !this.insuranceCoverageBool.value.brokenBone && this.insuranceCoverageBool.value.assisstent))
        ) {
          this.errorTitle = "Ukoliko je premija 12.9, ne može samo jedno dopnusko pokriće biti štiklirano";
          this.modalService.open(this.alertModal, { centered: true })
        } else {
          let startDate = '';
          if (this.insuredSumAndPremiumForm.get('insuranceStart').value) {
            startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
          } else {
            startDate = ''
          }
          this.draftModelFull = new StandardOSOffer({
            InsuranceStart: startDate,
            InsuranceEnd: '2000-01-01',
            OfferNumber: "",
            OfferType: 1,
            ContractorID: 0,
            InsureeID: 0,
            OneTimePayment: false,
            PaymentPeriodMonths: 0,
            Interest: 0,
            CreditAmount: 0,
            AdditionalIL: !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.thesisDisease : false,
            AdditionalBF: !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.brokenBone : false,
            AdditionalAS: !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.assisstent : false,
            Contractor: new OfferClient(
              this.basicInfo.data.contractorType == '1' ? '1' : '0',
              this.basicInfo.data.contractorFirstname,
              this.basicInfo.data.contractorLastname,
              this.basicInfo.data.contractorResponsibleName ? this.basicInfo.data.contractorResponsibleName : '',
              this.basicInfo.data.contractorJMBG ? this.basicInfo.data.contractorJMBG : '',
              this.basicInfo.data.contractorPhonenumber ? this.basicInfo.data.contractorPhonenumber : '',
              this.basicInfo.data.contractorEmail ? this.basicInfo.data.contractorEmail : '',
              this.basicInfo.data.contractorAddress ? this.basicInfo.data.contractorAddress : '',
              this.basicInfo.data.contractorSettlement ? this.basicInfo.data.contractorSettlement : '',
              this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode.toString() : "",
              this.basicInfo.data.contractorAddressOfDelivery ? this.basicInfo.data.contractorAddressOfDelivery : '',
              this.basicInfo.data.contractorSettlementOfDelivery ? this.basicInfo.data.contractorSettlementOfDelivery : '',
              this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery.toString() : "",
              0,
              "",
              "",
              0
            ),
            Insuree: new OfferInsuree(
              this.basicInfo.data.insuredFirstname ? this.basicInfo.data.insuredFirstname : '',
              this.basicInfo.data.insuredLastname ? this.basicInfo.data.insuredLastname : '',
              this.basicInfo.data.insuredJMBG ? this.basicInfo.data.insuredJMBG : '',
              this.basicInfo.data.insuredDOB ? this.basicInfo.data.insuredDOB : '',
              this.basicInfo.data.insuredMobile ? this.basicInfo.data.insuredMobile : '',
              this.basicInfo.data.insuredEmail ? this.basicInfo.data.insuredEmail : '',
              this.basicInfo.data.insuredAddress ? this.basicInfo.data.insuredAddress : '',
              this.basicInfo.data.insuredSettlement ? this.basicInfo.data.insuredSettlement : '',
              this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode.toString() : "",
              this.basicInfo.data.insuredJob ? this.basicInfo.data.insuredJob : '',
              0,
              0,
              0
            ),
            ProductType: 8,
            Gender: '',
            ContractorIsInsuree: this.basicInfo.data.contractorCopy,
            HazardLevel: 0,
            CigarettesPerDay: 0,
            Height: 0,
            Weight: 0,
            AdditionalInsuranceDeath: false,
            PaymentPeriodOut: 0,
            PaymentPeriodIn: 0,
            StartingAge: this.insuredSumAndPremiumForm.value.accessAge,
            Duration: 0,
            SumInsured: 0,
            PaymentPeriod: 0,
            RentPaymentFrequency: 0,
            RentPayment: 0,
            PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment),
            PaymentType: parseInt(this.insuredSumAndPremiumForm.value.methodPayment),
            ClientStatusID: null,
            PaymentInCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayment),
            PaymentOutCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayout),
            Comment: "",
            UserID: this.userId,
            NotificationsAgreement: this.checkBoxesForm.value.confirmSMS == '1' ? true : false,
            Verified: this.checkBoxesForm.value.confirmVeracity,
            Verified2: this.checkBoxesForm.value.confirmVeracity,
            Verified3: this.checkBoxesForm.value.confirmEmail == '1' ? true : false,
            Indexation: this.insuredSumAndPremiumForm.value.indexation == '' ? null : this.insuredSumAndPremiumForm.value.indexation == '0' ? false : true,
            HealthQuestionnaire: null,
            RedemptionAndCapitalization: null,
            Beneficiaries: this.insuranceUsers.length > 0 ? this.insuranceUsers : null,
            FATCAQuestionnaire: new FATCAQuestionnaire(
              0,
              null,
              null,
              null,
              null,
              null,
              null
            ),
            SPNFTForm: new SPNFTQuestionnaire(
              0,
              this.spnftForm.value.firstname ? this.spnftForm.value.firstname.toUpperCase() : '',
              this.spnftForm.value.lastname ? this.spnftForm.value.lastname.toUpperCase() : '',
              this.spnftForm.value.companyName ? this.spnftForm.value.companyName.toUpperCase() : '',
              this.spnftForm.value.jmbg ? this.spnftForm.value.jmbg : '',
              '',
              this.spnftForm.value.settlementob ? this.spnftForm.value.settlementob.toUpperCase() : '',
              this.spnftForm.value.address ? this.spnftForm.value.address.toUpperCase() : '',
              this.spnftForm.value.postalCode ? this.spnftForm.value.postalCode.toString() : "",
              this.spnftForm.value.settlement ? this.spnftForm.value.settlement.toUpperCase() : '',
              this.spnftForm.value.citizenship ? this.spnftForm.value.citizenship.toUpperCase() : '',
              this.spnftForm.value.legalRepresentativeFirstname ? this.spnftForm.value.legalRepresentativeFirstname.toUpperCase() : '',
              this.spnftForm.value.legalRepresentativeLastname ? this.spnftForm.value.legalRepresentativeLastname.toUpperCase() : '',
              this.spnftForm.value.representativeJmbg ? this.spnftForm.value.representativeJmbg : '',
              this.spnftForm.value.pib ? this.spnftForm.value.pib : '',
              this.spnftForm.value.mb ? this.spnftForm.value.mb : '',
              this.spnftForm.value.typeOfDocument ? this.spnftForm.value.typeOfDocument : '',
              this.spnftForm.value.numberOfDocument ? this.spnftForm.value.numberOfDocument : '',
              this.spnftForm.value.dateOfIssuringDocument ? this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0] : '',
              this.spnftForm.value.personalDocumentExpirationDate ? this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0] : '',
              this.spnftForm.value.placeOfIssuringDocument ? this.spnftForm.value.placeOfIssuringDocument.toUpperCase() : '',
              this.spnftForm.value.officialCloseFamily == 0 ? false : true,
              this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.officialPeriod : '',
              this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.closeFamilyName : '',
              this.spnftForm.value.cutomerAnotherPerson == '' ? null : this.spnftForm.value.cutomerAnotherPerson == '1' ? true : false,
              this.spnftForm.value.cutomerAnotherPersonRole ? this.spnftForm.value.cutomerAnotherPersonRole : null,
              this.spnftForm.value.firstnameOnBehalf ? this.spnftForm.value.firstnameOnBehalf.toUpperCase() : '',
              this.spnftForm.value.lastnameOnBehalf ? this.spnftForm.value.lastnameOnBehalf.toUpperCase() : '',
              this.spnftForm.value.jmbgOnBehalf ? this.spnftForm.value.jmbgOnBehalf : '',
              this.spnftForm.get('dobOnBehalf').value ? this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0] : '',
              this.spnftForm.value.settlementobOnBehalf ? this.spnftForm.value.settlementobOnBehalf.toUpperCase() : '',
              this.spnftForm.value.addressOnBehalf ? this.spnftForm.value.addressOnBehalf.toUpperCase() : '',
              this.spnftForm.value.postalCodeOnBehalf ? this.spnftForm.value.postalCodeOnBehalf.toString() : '',
              this.spnftForm.value.settlementOnBehalf ? this.spnftForm.value.settlementOnBehalf.toUpperCase() : '',
              this.spnftForm.value.idTypeOnBehalf ? this.spnftForm.value.idTypeOnBehalf : '',
              this.spnftForm.value.idNumberOnBehalf ? this.spnftForm.value.idNumberOnBehalf : '',
              this.spnftForm.value.idDate ? this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0] : '',
              this.spnftForm.value.idPlace ? this.spnftForm.value.idPlace.toUpperCase() : '',
              this.spnftForm.value.purposeOfBusinessRelation != '' ? this.spnftForm.value.purposeOfBusinessRelation : null,
              this.spnftForm.value.purposeOfBusinessRelation == '3' ? this.spnftForm.value.purposeOfBusinessRelationOther : '',
              this.spnftForm.value.originOfProperty != '' ? this.spnftForm.value.originOfProperty : null,
              this.spnftForm.value.originOfProperty == '3' ? this.spnftForm.value.originOfPropertyOther : ''
            ),
            PlatimatikForm: new PLATIMATICQuestionnaire(
              0,
              this.platimatikForm.value.firstname ? this.platimatikForm.value.firstname.toUpperCase() : '',
              this.platimatikForm.value.lastname ? this.platimatikForm.value.lastname.toUpperCase() : '',
              this.platimatikForm.value.address ? this.platimatikForm.value.address.toUpperCase() : '',
              this.platimatikForm.value.postalCode ? this.platimatikForm.value.postalCode.toString() : "",
              this.platimatikForm.value.placeOfResidence ? this.platimatikForm.value.placeOfResidence.toUpperCase() : '',
              this.platimatikForm.value.jmbg ? this.platimatikForm.value.jmbg : '',
              this.platimatikForm.value.bankName ? this.platimatikForm.value.bankName : '',
              this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber,
              this.platimatikForm.value.bankBic ? this.platimatikForm.value.bankBic : '',
              '',
              1,
              this.platimatikForm.get('validityFirstTermFrom').value ? this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0] : '',
              this.platimatikForm.get('validityFirstTermTo').value ? this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0] : '',
              this.platimatikForm.get('validitySecondTermFrom').value ? this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0] : '',
              this.platimatikForm.get('validitySecondTermTo').value ? this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0] : ''
            )
          })

          if (this.basicInfo.data.contractorType == '1') {
            this.draftModelFull.data.FATCAQuestionnaire.Q1NP = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q2NP = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
          } else {
            this.draftModelFull.data.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
            this.draftModelFull.data.FATCAQuestionnaire.Q1LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q2LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q3LE = false;
            this.draftModelFull.data.FATCAQuestionnaire.Q4LE = false;
          }

          switch (this.selectedPackage) {
            case 1:
              this.draftModelFull.data.PremiumRate = this.sentInformation.premiumRate[0];
              this.draftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[0];
              this.draftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[0];
              this.draftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[0];
              this.draftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[0];
              this.draftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[0];
              this.draftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[0];
              this.draftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[0];
              break;
            case 2:
              this.draftModelFull.data.PremiumRate = this.sentInformation.premiumRate[1];
              this.draftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[1];
              this.draftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[1];
              this.draftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[1];
              this.draftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[1];
              this.draftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[1];
              this.draftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[1];
              this.draftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[1];
              break;
            case 3:
              this.draftModelFull.data.PremiumRate = this.sentInformation.premiumRate[2];
              this.draftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[2];
              this.draftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[2];
              this.draftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[2];
              this.draftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[2];
              this.draftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[2];
              this.draftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[2];
              this.draftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[2];
              break;
            case 4:
              this.draftModelFull.data.PremiumRate = this.sentInformation.premiumRate[3];
              this.draftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[3];
              this.draftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[3];
              this.draftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[3];
              this.draftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[3];
              this.draftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[3];
              this.draftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[3];
              this.draftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[3];
              break;
            case 5:
              this.draftModelFull.data.PremiumRate = this.sentInformation.premiumRate[4];
              this.draftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[4];
              this.draftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[4];
              this.draftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[4];
              this.draftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[4];
              this.draftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[4];
              this.draftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[4];
              this.draftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[4];
              break;
            case 6:
              this.draftModelFull.data.PremiumRate = this.sentInformation.premiumRate[5];
              this.draftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[5];
              this.draftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[5];
              this.draftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[5];
              this.draftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[5];
              this.draftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[5];
              this.draftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[5];
              this.draftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[5];
              break;
            default:
              break;
          }

          console.log(this.draftModelFull)
          this.offerService.createDraftOffer(this.draftModelFull)
            .then(
              x => {
                this.successTitle = "Uspešno ste kreirali draft ponudu";
                this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
                this.resetAllForms()
                this.insuranceUsers = []
                this.formPlatimatikBool = false;
                this.formSpnftBool = false;
                this.noticeFatcaBool = false;
                this.healthQuestionnaireBool = false;
                this.calculcatorUsersBool = false;
                this.validInsuranceAndSumPremium = false;
                this.validUser = false;
                this.validSPNFT = false;
                this.validPLATIMATIK = false;
              },
              e => console.log(e)
            )
        }
      }
    }
  }

  updateDraft(draftTo) {
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname) {
        this.saveDraftService.addInfo();
        console.log("Nije uneto ime i prezime")
      } else {
        if (
          this.sentInformation.premiumRate[this.selectedPackage - 1] == 12.9 &&
          ((this.insuranceCoverageBool.value.thesisDisease && !this.insuranceCoverageBool.value.brokenBone && !this.insuranceCoverageBool.value.assisstent) || (!this.insuranceCoverageBool.value.thesisDisease && this.insuranceCoverageBool.value.brokenBone && !this.insuranceCoverageBool.value.assisstent) || (!this.insuranceCoverageBool.value.thesisDisease && !this.insuranceCoverageBool.value.brokenBone && this.insuranceCoverageBool.value.assisstent))
        ) {
          this.errorTitle = "Ukoliko je premija 12.9, ne može samo jedno dopnusko pokriće biti štiklirano";
          this.modalService.open(this.alertModal, { centered: true })
        } else {

          this.updateDraftModelFull.data.OfferType = 1
          this.updateDraftModelFull.data.OneTimePayment = false
          this.updateDraftModelFull.data.PaymentPeriodMonths = 0
          this.updateDraftModelFull.data.Interest = 0
          this.updateDraftModelFull.data.CreditAmount = 0
          this.updateDraftModelFull.data.AdditionalIL = !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.thesisDisease : false
          this.updateDraftModelFull.data.AdditionalBF = !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.brokenBone : false
          this.updateDraftModelFull.data.AdditionalAS = !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.assisstent : false

          this.updateDraftModelFull.data.Contractor.Firstname = this.basicInfo.data.contractorFirstname
          this.updateDraftModelFull.data.Contractor.Lastname = this.basicInfo.data.contractorLastname
          this.updateDraftModelFull.data.Contractor.CompanyName = this.basicInfo.data.contractorResponsibleName ? this.basicInfo.data.contractorResponsibleName : ''
          this.updateDraftModelFull.data.Contractor.JMBG = this.basicInfo.data.contractorJMBG ? this.basicInfo.data.contractorJMBG : ''
          this.updateDraftModelFull.data.Contractor.Mobile = this.basicInfo.data.contractorPhonenumber ? this.basicInfo.data.contractorPhonenumber : ''
          this.updateDraftModelFull.data.Contractor.Email = this.basicInfo.data.contractorEmail ? this.basicInfo.data.contractorEmail : ''
          this.updateDraftModelFull.data.Contractor.Address = this.basicInfo.data.contractorAddress ? this.basicInfo.data.contractorAddress : ''
          this.updateDraftModelFull.data.Contractor.Settlement = this.basicInfo.data.contractorSettlement ? this.basicInfo.data.contractorSettlement : ''
          this.updateDraftModelFull.data.Contractor.PostalCode = this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode : ''
          this.updateDraftModelFull.data.Contractor.DeliveryAddress = this.basicInfo.data.contractorAddressOfDelivery ? this.basicInfo.data.contractorAddressOfDelivery : ''
          this.updateDraftModelFull.data.Contractor.DeliverySettlement = this.basicInfo.data.contractorSettlementOfDelivery ? this.basicInfo.data.contractorSettlementOfDelivery : ''
          this.updateDraftModelFull.data.Contractor.DeliveryPostalCode = this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery : ''
          this.updateDraftModelFull.data.ContractorIsInsuree = this.basicInfo.data.contractorCopy

          this.updateDraftModelFull.data.Insuree.Firstname = this.basicInfo.data.insuredFirstname ? this.basicInfo.data.insuredFirstname : ''
          this.updateDraftModelFull.data.Insuree.Lastname = this.basicInfo.data.insuredLastname ? this.basicInfo.data.insuredLastname : ''
          this.updateDraftModelFull.data.Insuree.JMBG = this.basicInfo.data.insuredJMBG ? this.basicInfo.data.insuredJMBG : ''
          this.updateDraftModelFull.data.Insuree.DOB = this.basicInfo.data.insuredDOB ? this.basicInfo.data.insuredDOB : ''
          this.updateDraftModelFull.data.Insuree.Mobile = this.basicInfo.data.insuredMobile ? this.basicInfo.data.insuredMobile : ''
          this.updateDraftModelFull.data.Insuree.Email = this.basicInfo.data.insuredEmail ? this.basicInfo.data.insuredEmail : ''
          this.updateDraftModelFull.data.Insuree.Address = this.basicInfo.data.insuredAddress ? this.basicInfo.data.insuredAddress : ''
          this.updateDraftModelFull.data.Insuree.Settlement = this.basicInfo.data.insuredSettlement ? this.basicInfo.data.insuredSettlement : ''
          this.updateDraftModelFull.data.Insuree.PostalCode = this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode : ''
          this.updateDraftModelFull.data.Insuree.Occupation = this.basicInfo.data.insuredJob ? this.basicInfo.data.insuredJob : ''

          let startDate = '';
          if (this.insuredSumAndPremiumForm.get('insuranceStart').value) {
            startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
          } else {
            startDate = ''
          }
          this.updateDraftModelFull.data.InsuranceStart = startDate;
          this.updateDraftModelFull.data.InsuranceEnd = '2000-01-01';

          this.updateDraftModelFull.data.Gender = ''
          this.updateDraftModelFull.data.HazardLevel = 0
          this.updateDraftModelFull.data.CigarettesPerDay = 0
          this.updateDraftModelFull.data.Height = 0
          this.updateDraftModelFull.data.Weight = 0
          this.updateDraftModelFull.data.AdditionalInsuranceDeath = false
          this.updateDraftModelFull.data.PaymentPeriodOut = 0
          this.updateDraftModelFull.data.PaymentPeriodIn = 0
          this.updateDraftModelFull.data.StartingAge = this.insuredSumAndPremiumForm.value.accessAge
          this.updateDraftModelFull.data.Duration = 0
          this.updateDraftModelFull.data.PaymentPeriod = 0
          this.updateDraftModelFull.data.RentPaymentFrequency = 0
          this.updateDraftModelFull.data.RentPayment = 0
          this.updateDraftModelFull.data.PaymentFrequency = parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment)
          this.updateDraftModelFull.data.PaymentType = parseInt(this.insuredSumAndPremiumForm.value.methodPayment)
          this.updateDraftModelFull.data.PaymentInCurrency = parseInt(this.insuredSumAndPremiumForm.value.currencyPayment)
          this.updateDraftModelFull.data.PaymentOutCurrency = parseInt(this.insuredSumAndPremiumForm.value.currencyPayout)
          this.updateDraftModelFull.data.UserID = this.userId
          this.updateDraftModelFull.data.NotificationsAgreement = this.checkBoxesForm.value.confirmSMS == '1' ? true : false
          this.updateDraftModelFull.data.Verified = this.checkBoxesForm.value.confirmVeracity
          this.updateDraftModelFull.data.Verified2 = this.checkBoxesForm.value.confirmData
          this.updateDraftModelFull.data.Verified3 = this.checkBoxesForm.value.confirmEmail == '1' ? true : false
          this.updateDraftModelFull.data.Indexation = this.insuredSumAndPremiumForm.value.indexation == '' ? null : this.insuredSumAndPremiumForm.value.indexation == '0' ? false : true

          switch (this.selectedPackage) {
            case 1:
              this.updateDraftModelFull.data.PremiumRate = this.sentInformation.premiumRate[0];
              this.updateDraftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[0];
              this.updateDraftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[0];
              this.updateDraftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[0];
              this.updateDraftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[0];
              this.updateDraftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[0];
              this.updateDraftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[0];
              this.updateDraftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[0];
              break;
            case 2:
              this.updateDraftModelFull.data.PremiumRate = this.sentInformation.premiumRate[1];
              this.updateDraftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[1];
              this.updateDraftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[1];
              this.updateDraftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[1];
              this.updateDraftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[1];
              this.updateDraftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[1];
              this.updateDraftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[1];
              this.updateDraftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[1];
              break;
            case 3:
              this.updateDraftModelFull.data.PremiumRate = this.sentInformation.premiumRate[2];
              this.updateDraftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[2];
              this.updateDraftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[2];
              this.updateDraftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[2];
              this.updateDraftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[2];
              this.updateDraftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[2];
              this.updateDraftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[2];
              this.updateDraftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[2];
              break;
            case 4:
              this.updateDraftModelFull.data.PremiumRate = this.sentInformation.premiumRate[3];
              this.updateDraftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[3];
              this.updateDraftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[3];
              this.updateDraftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[3];
              this.updateDraftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[3];
              this.updateDraftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[3];
              this.updateDraftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[3];
              this.updateDraftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[3];
              break;
            case 5:
              this.updateDraftModelFull.data.PremiumRate = this.sentInformation.premiumRate[4];
              this.updateDraftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[4];
              this.updateDraftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[4];
              this.updateDraftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[4];
              this.updateDraftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[4];
              this.updateDraftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[4];
              this.updateDraftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[4];
              this.updateDraftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[4];
              break;
            case 6:
              this.updateDraftModelFull.data.PremiumRate = this.sentInformation.premiumRate[5];
              this.updateDraftModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[5];
              this.updateDraftModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[5];
              this.updateDraftModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[5];
              this.updateDraftModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[5];
              this.updateDraftModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[5];
              this.updateDraftModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[5];
              this.updateDraftModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[5];
              break;
            default:
              break;
          }

          if (this.insuranceUsers.length > 0)
            this.updateDraftModelFull.data.Beneficiaries = this.insuranceUsers

          this.updateDraftModelFull.data.HealthQuestionnaire = null

          if (this.basicInfo.data.contractorType == '1') {
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q1NP = false;
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q2NP = false;
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
          } else {
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q1LE = false;
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q2LE = false;
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q3LE = false;
            this.updateDraftModelFull.data.FATCAQuestionnaire.Q4LE = false;
          }

          if (this.spnftForm.value.firstname)
            this.updateDraftModelFull.data.SPNFTForm.Firstname = this.spnftForm.value.firstname.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.Firstname = ''
          if (this.spnftForm.value.lastname)
            this.updateDraftModelFull.data.SPNFTForm.Lastname = this.spnftForm.value.lastname.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.Lastname = ''
          if (this.spnftForm.value.companyName)
            this.updateDraftModelFull.data.SPNFTForm.CompanyName = this.spnftForm.value.companyName.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.CompanyName = ''
          // if (this.spnftForm.value.companyName)
          //   this.updateDraftModelFull.data.SPNFTForm.CompanyName = this.spnftForm.value.companyName
          // else
          //   this.updateDraftModelFull.data.SPNFTForm.CompanyName = ''
          if (this.spnftForm.value.jmbg)
            this.updateDraftModelFull.data.SPNFTForm.JMBG = this.spnftForm.value.jmbg
          else
            this.updateDraftModelFull.data.SPNFTForm.JMBG = ''
          if (this.spnftForm.value.settlementob)
            this.updateDraftModelFull.data.SPNFTForm.PlaceOfBirth = this.spnftForm.value.settlementob.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.PlaceOfBirth = ''
          if (this.spnftForm.value.address)
            this.updateDraftModelFull.data.SPNFTForm.Address = this.spnftForm.value.address.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.Address = ''
          if (this.spnftForm.value.postalCode)
            this.updateDraftModelFull.data.SPNFTForm.PostalCode = this.spnftForm.value.postalCode
          else
            this.updateDraftModelFull.data.SPNFTForm.PostalCode = ''
          if (this.spnftForm.value.settlement)
            this.updateDraftModelFull.data.SPNFTForm.Settlement = this.spnftForm.value.settlement.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.Settlement = ''
          if (this.spnftForm.value.citizenship)
            this.updateDraftModelFull.data.SPNFTForm.Citizenship = this.spnftForm.value.citizenship.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.Citizenship = ''
          if (this.spnftForm.value.legalRepresentativeFirstname)
            this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeFirtsname = this.spnftForm.value.legalRepresentativeFirstname.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeFirtsname = ''
          if (this.spnftForm.value.legalRepresentativeLastname)
            this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeLastname = this.spnftForm.value.legalRepresentativeLastname.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeLastname = ''
          if (this.spnftForm.value.representativeJmbg)
            this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeJMBG = this.spnftForm.value.representativeJmbg
          else
            this.updateDraftModelFull.data.SPNFTForm.LegalRepresentativeJMBG = ''
          if (this.spnftForm.value.pib)
            this.updateDraftModelFull.data.SPNFTForm.TaxID = this.spnftForm.value.pib
          else
            this.updateDraftModelFull.data.SPNFTForm.TaxID = ''
          if (this.spnftForm.value.mb)
            this.updateDraftModelFull.data.SPNFTForm.CompanyID = this.spnftForm.value.mb
          else
            this.updateDraftModelFull.data.SPNFTForm.CompanyID = ''
          if (this.spnftForm.value.typeOfDocument)
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentType = this.spnftForm.value.typeOfDocument
          else
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentType = ''
          if (this.spnftForm.value.numberOfDocument)
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentNumber = this.spnftForm.value.numberOfDocument
          else
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentNumber = ''
          if (this.spnftForm.value.dateOfIssuringDocument)
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0]
          else
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = ''
          if (this.spnftForm.value.personalDocumentExpirationDate)
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0]
          else
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = ''
          if (this.spnftForm.value.placeOfIssuringDocument)
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentIssuedPlace = this.spnftForm.value.placeOfIssuringDocument.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.PersonalDocumentIssuedPlace = ''
          if (this.spnftForm.value.officialCloseFamily == 0)
            this.updateDraftModelFull.data.SPNFTForm.IsPoliticianOrCloseAssociate = false
          else
            this.updateDraftModelFull.data.SPNFTForm.IsPoliticianOrCloseAssociate = true
          if (this.spnftForm.value.officialCloseFamily == 1)
            this.updateDraftModelFull.data.SPNFTForm.InOffice = this.spnftForm.value.officialPeriod
          else
            this.updateDraftModelFull.data.SPNFTForm.InOffice = ''
          if (this.spnftForm.value.officialCloseFamily == 1)
            this.updateDraftModelFull.data.SPNFTForm.RemarkIfYes = this.spnftForm.value.closeFamilyName
          else
            this.updateDraftModelFull.data.SPNFTForm.RemarkIfYes = ''
          if (this.spnftForm.value.cutomerAnotherPerson == '')
            this.updateDraftModelFull.data.SPNFTForm.ClientAppliesThroughIntermediary = null
          else
            if (this.spnftForm.value.cutomerAnotherPerson == '1')
              this.updateDraftModelFull.data.SPNFTForm.ClientAppliesThroughIntermediary = true
            else
              this.updateDraftModelFull.data.SPNFTForm.ClientAppliesThroughIntermediary = false
          if (this.spnftForm.value.cutomerAnotherPersonRole)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryType = this.spnftForm.value.cutomerAnotherPersonRole
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryType = null
          if (this.spnftForm.value.firstnameOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryFirstname = this.spnftForm.value.firstnameOnBehalf.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryFirstname = ''
          if (this.spnftForm.value.lastnameOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryLastname = this.spnftForm.value.lastnameOnBehalf.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryLastname = ''
          if (this.spnftForm.value.jmbgOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryJMBG = this.spnftForm.value.jmbgOnBehalf
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryJMBG = ''
          if (this.spnftForm.get('dob').value)
            this.updateDraftModelFull.data.SPNFTForm.DateOfBirth = this.spnftForm.get('dob').value.split('.')[2] + '-' + this.spnftForm.get('dob').value.split('.')[1] + '-' + this.spnftForm.get('dob').value.split('.')[0]
          else
            this.updateDraftModelFull.data.SPNFTForm.DateOfBirth = ''
          if (this.spnftForm.get('dobOnBehalf').value)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryDateOfBirth = this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0]
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryDateOfBirth = ''
          if (this.spnftForm.value.settlementobOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPlaceOfBirth = this.spnftForm.value.settlementobOnBehalf.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPlaceOfBirth = ''
          if (this.spnftForm.value.addressOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryAddress = this.spnftForm.value.addressOnBehalf.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryAddress = ''
          if (this.spnftForm.value.postalCodeOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPostalCode = this.spnftForm.value.postalCodeOnBehalf
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPostalCode = ''
          if (this.spnftForm.value.settlementOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediarySettlement = this.spnftForm.value.settlementOnBehalf.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediarySettlement = ''
          if (this.spnftForm.value.idTypeOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentType = this.spnftForm.value.idTypeOnBehalf
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentType = ''
          if (this.spnftForm.value.idNumberOnBehalf)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentNumber = this.spnftForm.value.idNumberOnBehalf
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentNumber = ''
          if (this.spnftForm.value.idDate)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0]
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = ''
          if (this.spnftForm.value.idPlace)
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedPlace = this.spnftForm.value.idPlace.toUpperCase()
          else
            this.updateDraftModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedPlace = ''
          if (this.spnftForm.value.purposeOfBusinessRelation != '')
            this.updateDraftModelFull.data.SPNFTForm.BusinessRelationshipClientPurpose = this.spnftForm.value.purposeOfBusinessRelation
          else
            this.updateDraftModelFull.data.SPNFTForm.BusinessRelationshipClientPurpose = null
          if (this.spnftForm.value.purposeOfBusinessRelation == '3')
            this.updateDraftModelFull.data.SPNFTForm.BusinessRelationshipClientPurposeOther = this.spnftForm.value.purposeOfBusinessRelationOther
          else
            this.updateDraftModelFull.data.SPNFTForm.BusinessRelationshipClientPurposeOther = ''
          if (this.spnftForm.value.originOfProperty != '')
            this.updateDraftModelFull.data.SPNFTForm.PropertyOrigin = this.spnftForm.value.originOfProperty
          else
            this.updateDraftModelFull.data.SPNFTForm.PropertyOrigin = null
          if (this.spnftForm.value.originOfProperty == '3')
            this.updateDraftModelFull.data.SPNFTForm.PropertyOriginOther = this.spnftForm.value.originOfPropertyOther
          else
            this.updateDraftModelFull.data.SPNFTForm.PropertyOriginOther = ''


          if (this.platimatikForm.value.firstname)
            this.updateDraftModelFull.data.PlatimatikForm.Firstname = this.platimatikForm.value.firstname.toUpperCase()
          else
            this.updateDraftModelFull.data.PlatimatikForm.Firstname = ''
          if (this.platimatikForm.value.lastname)
            this.updateDraftModelFull.data.PlatimatikForm.Lastname = this.platimatikForm.value.lastname.toUpperCase()
          else
            this.updateDraftModelFull.data.PlatimatikForm.Lastname = ''
          if (this.platimatikForm.value.address)
            this.updateDraftModelFull.data.PlatimatikForm.Address = this.platimatikForm.value.address.toUpperCase()
          else
            this.updateDraftModelFull.data.PlatimatikForm.Address = ''
          if (this.platimatikForm.value.postalCode)
            this.updateDraftModelFull.data.PlatimatikForm.PostalCode = this.platimatikForm.value.postalCode
          else
            this.updateDraftModelFull.data.PlatimatikForm.PostalCode = ''
          if (this.platimatikForm.value.placeOfResidence)
            this.updateDraftModelFull.data.PlatimatikForm.Settlement = this.platimatikForm.value.placeOfResidence.toUpperCase()
          else
            this.updateDraftModelFull.data.PlatimatikForm.Settlement = ''
          if (this.platimatikForm.value.jmbg)
            this.updateDraftModelFull.data.PlatimatikForm.JMBG = this.platimatikForm.value.jmbg
          else
            this.updateDraftModelFull.data.PlatimatikForm.JMBG = ''
          if (this.platimatikForm.value.bankName)
            this.updateDraftModelFull.data.PlatimatikForm.Bank = this.platimatikForm.value.bankName
          else
            this.updateDraftModelFull.data.PlatimatikForm.Bank = ''
          this.updateDraftModelFull.data.PlatimatikForm.AccountNumber = this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber
          if (this.platimatikForm.value.bankBic)
            this.updateDraftModelFull.data.PlatimatikForm.BIC = this.platimatikForm.value.bankBic
          else
            this.updateDraftModelFull.data.PlatimatikForm.BIC = ''
          this.updateDraftModelFull.data.PlatimatikForm.ContractNumber = ''
          this.updateDraftModelFull.data.PlatimatikForm.Currency = 1
          if (this.platimatikForm.get('validityFirstTermFrom').value)
            this.updateDraftModelFull.data.PlatimatikForm.FirstMandateFrom = this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0]
          else
            this.updateDraftModelFull.data.PlatimatikForm.FirstMandateFrom = ''
          if (this.platimatikForm.get('validityFirstTermTo').value)
            this.updateDraftModelFull.data.PlatimatikForm.FirstMandateTo = this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0]
          else
            this.updateDraftModelFull.data.PlatimatikForm.FirstMandateTo = ''
          if (this.platimatikForm.get('validitySecondTermFrom').value)
            this.updateDraftModelFull.data.PlatimatikForm.SecondMandateFrom = this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0]
          else
            this.updateDraftModelFull.data.PlatimatikForm.SecondMandateFrom = ''
          if (this.platimatikForm.get('validitySecondTermTo').value)
            this.updateDraftModelFull.data.PlatimatikForm.SecondMandateTo = this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0]
          else
            this.updateDraftModelFull.data.PlatimatikForm.SecondMandateTo = ''

          console.log(this.updateDraftModelFull)
          this.offerService.editDraftOffer(this.updateDraftModelFull)
            .then(
              x => {
                if (draftTo == 0) {
                  this.successTitle = "Uspešno ste sačuvali promene";
                  this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
                } else if (draftTo == 1) {
                  this.offerService.createFromDraftOffer(this.offerId)
                    .then(
                      x => {
                        this.riskAssessmentForm.reset();
                        this.modalService.open(this.riskFormModal, { size: 'xl', backdrop: 'static', keyboard: false })
                        if (this.spnftForm.value.officialCloseFamily == '1') {
                          this.riskAssessmentForm.get('question11').setValue('0');
                          this.riskAssessmentForm.get('question11').disable();
                        } else {
                          this.riskAssessmentForm.get('question11').enable();
                        }
                      },
                      (x: any) => {
                        console.log(x)
                        this.errorTitle = x.error;
                        this.modalService.open(this.alertModal, { centered: true })
                      }
                    )
                } else if (draftTo == 2) {
                  this.offerService.createFromDraftOffer(this.offerId)
                    .then(
                      x => {
                        this.offerService.sendLocalDocuments(this.offerId)
                          .then(
                            x => {
                              this.modalService.dismissAll();
                              this.resetAllForms()
                              this.insuranceUsers = []
                              this.formPlatimatikBool = false;
                              this.formSpnftBool = false;
                              this.noticeFatcaBool = false;
                              this.healthQuestionnaireBool = false;
                              this.calculcatorUsersBool = false;
                              this.validInsuranceAndSumPremium = false;
                              this.validUser = false;
                              this.validSPNFT = false;
                              this.validPLATIMATIK = false;
                              this.router.navigate(['/sign-documents-on-spot/' + this.offerId]);
                              // this.router.navigate([]).then(r => { window.open('/sign-documents-on-spot/' + this.offerId, '_blank') })
                            }
                          )
                      },
                      (x: any) => {
                        console.log(x)
                        this.errorTitle = x.error;
                        this.modalService.open(this.alertModal, { centered: true })
                      }
                    )
                }

              },
              e => console.log(e)
            )

        }
      }
    }
  }

  draftToDigital() {
    this.userValue = true;
    loop1:
    for (let i = 0; i < this.roles.length; i++) {
      loop2:
      for (let j = 0; j < this.insuranceUsers.length; j++) {
        if (this.roles[i].productRoleID == this.insuranceUsers[j].RoleID) {
          this.userValue = false;
          break loop2;
        }
      }
      if (i + 1 == this.roles.length) {
        if (!this.userValue) {
          break loop1;
        }
      }
      if (!this.userValue) {
        this.userValue = true
      } else {
        break loop1;
      }
    }

    let helthBool = false;
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (
        this.sentInformation.premiumRate[this.selectedPackage - 1] == 12.9 &&
        ((this.insuranceCoverageBool.value.thesisDisease && !this.insuranceCoverageBool.value.brokenBone && !this.insuranceCoverageBool.value.assisstent) || (!this.insuranceCoverageBool.value.thesisDisease && this.insuranceCoverageBool.value.brokenBone && !this.insuranceCoverageBool.value.assisstent) || (!this.insuranceCoverageBool.value.thesisDisease && !this.insuranceCoverageBool.value.brokenBone && this.insuranceCoverageBool.value.assisstent))
      ) {
        this.errorTitle = "Ukoliko je premija 12.9, ne može samo jedno dopnusko pokriće biti štiklirano";
        this.modalService.open(this.alertModal, { centered: true })
      } else {


        if (!this.userSignature) {
          this.errorTitle = "Nemate potpis";
          this.modalService.open(this.alertModal, { centered: true })
        } else {
          let mobileRegex = new RegExp('0[0-9]{7,9}')
          let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
          if (this.basicInfo.data.contractorType == '1') {
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || !this.basicInfo.data.contractorPIB || !this.basicInfo.data.contractorResponsibleName || !this.basicInfo.data.contractorID || this.basicInfo.data.contractorJMBG.length != 13 || this.basicInfo.data.contractorPIB.length != 9 || this.basicInfo.data.contractorID.length != 8) {
              this.digitalService.addInfo(true);
            } else {
              if (!this.basicInfo.data.insuredFirstname || !this.basicInfo.data.insuredLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !emailRegex.test(this.basicInfo.data.insuredEmail.toString()) || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                this.digitalService.addInfo(true);
              } else {
                if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.indexation || !this.insuredSumAndPremiumForm.value.methodPayment) {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      if (!this.fatcaForm.value.insuredLegalEntitySad || !this.fatcaForm.value.insuredTaxpayerSad || !this.fatcaForm.value.insuredTenPrecentShare || !this.fatcaForm.value.insuredFinancialInstitution) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname || !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13) {
              console.log("Prosle basic")
              console.log(this.basicInfo)
              this.digitalService.addInfo(true);
            } else {
              if (!this.basicInfo.data.insuredFirstname || !this.basicInfo.data.insuredLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !emailRegex.test(this.basicInfo.data.insuredEmail.toString()) || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                console.log(this.basicInfo.data)
                console.log('prosole insured')
                this.digitalService.addInfo(true);
              } else {
                if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.indexation || !this.insuredSumAndPremiumForm.value.methodPayment) {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  console.log("Prosle currency")
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    console.log("Prosli korisnici")
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      console.log("Prosao zdravstveni")
                      if (!this.fatcaForm.value.citizenshipSad || !this.fatcaForm.value.texpayerSad) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname ||
                          !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          console.log("Prosao spnft")
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              console.log("Prosao platiomatik")
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }


  validInsuranceAndSumPremium: Boolean = false;
  validUser: Boolean = false;
  validSPNFT: Boolean = false;
  validPLATIMATIK: Boolean = false;
  userValue;
  offerModelFull: StandardOSOffer;
  saveDigital() {
    // console.log(this.hideExport)
    // console.log(this.basicInfo.data)

    this.userValue = true;
    loop1:
    for (let i = 0; i < this.roles.length; i++) {
      loop2:
      for (let j = 0; j < this.insuranceUsers.length; j++) {
        if (this.roles[i].productRoleID == this.insuranceUsers[j].RoleID) {
          this.userValue = false;
          break loop2;
        }
      }
      if (i + 1 == this.roles.length) {
        if (!this.userValue) {
          break loop1;
        }
      }
      if (!this.userValue) {
        this.userValue = true
      } else {
        break loop1;
      }
    }


    let startDate = '';
    if (this.insuredSumAndPremiumForm.get('insuranceStart').value) {
      startDate = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0];
    } else {
      startDate = ''
    }

    this.offerModelFull = new StandardOSOffer({
      InsuranceStart: startDate,
      InsuranceEnd: '2000-01-01',
      OfferNumber: "",
      OfferType: 1,
      ContractorID: 0,
      InsureeID: 0,
      OneTimePayment: false,
      PaymentPeriodMonths: 0,
      Interest: 0,
      CreditAmount: 0,
      AdditionalIL: !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.thesisDisease : false,
      AdditionalBF: !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.brokenBone : false,
      AdditionalAS: !this.supplementaryIsnuranceHideAllBool ? this.insuranceCoverageBool.value.assisstent : false,
      Contractor: new OfferClient(
        this.basicInfo.data.contractorType == '1' ? '1' : '0',
        this.basicInfo.data.contractorFirstname,
        this.basicInfo.data.contractorLastname,
        this.basicInfo.data.contractorResponsibleName,
        this.basicInfo.data.contractorJMBG,
        this.basicInfo.data.contractorPhonenumber,
        this.basicInfo.data.contractorEmail,
        this.basicInfo.data.contractorAddress,
        this.basicInfo.data.contractorSettlement,
        this.basicInfo.data.contractorPostalCode,
        this.basicInfo.data.contractorAddressOfDelivery,
        this.basicInfo.data.contractorSettlementOfDelivery,
        this.basicInfo.data.contractorPostalCodeOfDelivery,
        0,
        "",
        ""
      ),
      Insuree: new OfferInsuree(
        this.basicInfo.data.insuredFirstname,
        this.basicInfo.data.insuredLastname,
        this.basicInfo.data.insuredJMBG,
        this.basicInfo.data.insuredDOB,
        this.basicInfo.data.insuredMobile,
        this.basicInfo.data.insuredEmail,
        this.basicInfo.data.insuredAddress,
        this.basicInfo.data.insuredSettlement,
        this.basicInfo.data.insuredPostalCode,
        '',
        0,
        0
      ),
      ProductType: 8,
      Gender: '',
      ContractorIsInsuree: this.basicInfo.data.contractorCopy,
      HazardLevel: 0,
      CigarettesPerDay: 0,
      Height: 0,
      Weight: 0,
      AdditionalInsuranceDeath: false,
      PaymentPeriodOut: 0,
      PaymentPeriodIn: 0,
      StartingAge: this.insuredSumAndPremiumForm.value.accessAge,
      Duration: 0,
      SumInsured: 0,
      PaymentPeriod: 0,
      RentPaymentFrequency: 0,
      RentPayment: 0,
      PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment),
      PaymentType: parseInt(this.insuredSumAndPremiumForm.value.methodPayment),
      ClientStatusID: null,
      PaymentInCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayment),
      PaymentOutCurrency: parseInt(this.insuredSumAndPremiumForm.value.currencyPayout),
      Comment: "",
      UserID: this.userId,
      NotificationsAgreement: this.checkBoxesForm.value.confirmSMS == '1' ? true : false,
      Verified: this.checkBoxesForm.value.confirmVeracity,
      Verified2: this.checkBoxesForm.value.confirmVeracity,
      Verified3: this.checkBoxesForm.value.confirmEmail == '1' ? true : false,
      Beneficiaries: this.insuranceUsers,
      HealthQuestionnaire: null,
      FATCAQuestionnaire: new FATCAQuestionnaire(
        0
      ),
      SPNFTForm: new SPNFTQuestionnaire(
        0,
        this.spnftForm.value.firstname ? this.spnftForm.value.firstname.toUpperCase() : '',
        this.spnftForm.value.lastname ? this.spnftForm.value.lastname.toUpperCase() : '',
        this.spnftForm.value.companyName ? this.spnftForm.value.companyName.toUpperCase() : '',
        this.spnftForm.value.jmbg,
        '',
        this.spnftForm.value.settlementob ? this.spnftForm.value.settlementob.toUpperCase() : '',
        this.spnftForm.value.address ? this.spnftForm.value.address.toUpperCase() : '',
        this.spnftForm.value.postalCode,
        this.spnftForm.value.settlement ? this.spnftForm.value.settlement.toUpperCase() : '',
        this.spnftForm.value.citizenship ? this.spnftForm.value.citizenship.toUpperCase() : '',
        this.spnftForm.value.legalRepresentativeFirstname ? this.spnftForm.value.legalRepresentativeFirstname.toUpperCase() : '',
        this.spnftForm.value.legalRepresentativeLastname ? this.spnftForm.value.legalRepresentativeLastname.toUpperCase() : '',
        this.spnftForm.value.representativeJmbg,
        this.spnftForm.value.pib,
        this.spnftForm.value.mb,
        this.spnftForm.value.typeOfDocument,
        this.spnftForm.value.numberOfDocument,
        '',
        this.spnftForm.value.personalDocumentExpirationDate ? this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0] : '',
        this.spnftForm.value.placeOfIssuringDocument ? this.spnftForm.value.placeOfIssuringDocument.toUpperCase() : '',
        this.spnftForm.value.officialCloseFamily == 0 ? false : true,
        this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.officialPeriod : '',
        this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.closeFamilyName : '',
        !this.spnftForm.value.cutomerAnotherPerson ? false : this.spnftForm.value.cutomerAnotherPerson == '1' ? true : false,
        this.spnftForm.value.cutomerAnotherPersonRole ? this.spnftForm.value.cutomerAnotherPersonRole : null,
        this.spnftForm.value.firstnameOnBehalf ? this.spnftForm.value.firstnameOnBehalf.toUpperCase() : '',
        this.spnftForm.value.lastnameOnBehalf ? this.spnftForm.value.lastnameOnBehalf.toUpperCase() : '',
        this.spnftForm.value.jmbgOnBehalf,
        '',
        this.spnftForm.value.settlementobOnBehalf ? this.spnftForm.value.settlementobOnBehalf.toUpperCase() : '',
        this.spnftForm.value.addressOnBehalf ? this.spnftForm.value.addressOnBehalf.toUpperCase() : '',
        this.spnftForm.value.postalCodeOnBehalf,
        this.spnftForm.value.settlementOnBehalf ? this.spnftForm.value.settlementOnBehalf.toUpperCase() : '',
        this.spnftForm.value.idTypeOnBehalf,
        this.spnftForm.value.idNumberOnBehalf,
        '',
        this.spnftForm.value.idPlace ? this.spnftForm.value.idPlace.toUpperCase() : '',
        this.spnftForm.value.purposeOfBusinessRelation,
        this.spnftForm.value.purposeOfBusinessRelation == '3' ? this.spnftForm.value.purposeOfBusinessRelationOther : '',
        this.spnftForm.value.originOfProperty,
        this.spnftForm.value.originOfProperty == '3' ? this.spnftForm.value.originOfPropertyOther : ''
      ),
      PlatimatikForm: new PLATIMATICQuestionnaire(
        0,
        this.platimatikForm.value.firstname ? this.platimatikForm.value.firstname.toUpperCase() : '',
        this.platimatikForm.value.lastname ? this.platimatikForm.value.lastname.toUpperCase() : '',
        this.platimatikForm.value.address ? this.platimatikForm.value.address.toUpperCase() : '',
        this.platimatikForm.value.postalCode,
        this.platimatikForm.value.placeOfResidence ? this.platimatikForm.value.placeOfResidence.toUpperCase() : '',
        this.platimatikForm.value.jmbg,
        this.platimatikForm.value.bankName,
        this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber,
        this.platimatikForm.value.bankBic,
        '',
        1,
        this.platimatikForm.get('validityFirstTermFrom').value ? this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0] : '',
        this.platimatikForm.get('validityFirstTermTo').value ? this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0] : '',
        this.platimatikForm.get('validitySecondTermFrom').value ? this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0] : '',
        this.platimatikForm.get('validitySecondTermTo').value ? this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0] : '',
      )
    })
    if (this.spnftForm.get('dobOnBehalf').value) {
      this.offerModelFull.data.SPNFTForm.IntermediaryDateOfBirth = this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.IntermediaryDateOfBirth = ''
    }
    if (this.spnftForm.get('dob').value) {
      this.offerModelFull.data.SPNFTForm.DateOfBirth = this.spnftForm.get('dob').value.split('.')[2] + '-' + this.spnftForm.get('dob').value.split('.')[1] + '-' + this.spnftForm.get('dob').value.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.DateOfBirth = ''
    }
    if (this.spnftForm.value.dateOfIssuringDocument) {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentIssuedDate = ''
    }
    if (this.spnftForm.value.personalDocumentExpirationDate) {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.PersonalDocumentExpirationDate = ''
    }
    if (this.spnftForm.value.idDate) {
      this.offerModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0]
    } else {
      this.offerModelFull.data.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = ''
    }
    if (this.basicInfo.data.contractorType == '1') {
      this.offerModelFull.data.Contractor.TaxID = this.basicInfo.data.contractorPIB;
      this.offerModelFull.data.Contractor.CompanyID = this.basicInfo.data.contractorID;
      this.offerModelFull.data.Contractor.ClientType = '1';
      this.offerModelFull.data.FATCAQuestionnaire.Q1NP = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q2NP = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
    } else {
      this.offerModelFull.data.Contractor.TaxID = '';
      this.offerModelFull.data.Contractor.CompanyID = '';
      this.offerModelFull.data.Contractor.ClientType = '0';
      this.offerModelFull.data.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
      this.offerModelFull.data.FATCAQuestionnaire.Q1LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q2LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q3LE = false;
      this.offerModelFull.data.FATCAQuestionnaire.Q4LE = false;
    }
    if (this.insuredSumAndPremiumForm.value.indexation == '0') {
      this.offerModelFull.data.Indexation = false;
    } else {
      this.offerModelFull.data.Indexation = true;
    }



    let helthBool = false;
    // if (
    //   !this.healthForm.value.threeMonthStayAbroad ||
    //   (this.healthForm.value.threeMonthStayAbroad == '0' && !this.healthForm.value.threeMonthStayAbroadDescription) ||
    //   !this.healthForm.value.deniedAcceptedRequest ||
    //   (this.healthForm.value.deniedAcceptedRequest == '0' && !this.healthForm.value.deniedacceptedRequestDescription) ||
    //   !this.healthForm.value.sportActivity ||
    //   (this.healthForm.value.sportActivity == '0' && !this.healthForm.value.sportActivityDescription) ||
    //   !this.healthForm.value.constantDoctorTreats ||
    //   (this.healthForm.value.constantDoctorTreats == '0' && !this.healthForm.value.constantDoctorTreatsDescription) ||
    //   !this.healthForm.value.specialMedicalExamination ||
    //   (this.healthForm.value.specialMedicalExamination == '0' && !this.healthForm.value.specialMedicalExaminationDescription) ||
    //   !this.healthForm.value.takingMedicines ||
    //   (this.healthForm.value.takingMedicines == '0' && !this.healthForm.value.takingMedicinesDescription) ||
    //   !this.healthForm.value.alcoholOrIntoxicants ||
    //   (this.healthForm.value.alcoholOrIntoxicants == '0' && !this.healthForm.value.alcoholOrIntoxicantsDescription) ||
    //   !this.healthForm.value.helpForAlcoholAddiction ||
    //   (this.healthForm.value.helpForAlcoholAddiction == '0' && !this.healthForm.value.helpForAlcoholAddictionDescription) ||
    //   !this.healthForm.value.consumeCigarettes ||
    //   (this.healthForm.value.consumeCigarettes == '0' && !this.healthForm.value.consumeCigarettesDescription) ||
    //   !this.healthForm.value.seriousIllness ||
    //   (this.healthForm.value.seriousIllness == '0' && !this.healthForm.value.seriousIllnessDescription) ||
    //   !this.healthForm.value.dangerAtWork ||
    //   (this.healthForm.value.dangerAtWork == '0' && !this.healthForm.value.dangerAtWorkDescription) ||
    //   !this.healthForm.value.tenYearMedicalTests ||
    //   (this.healthForm.value.tenYearMedicalTests == '0' && !this.healthForm.value.tenYearmedicalTestsDescription) ||
    //   !this.healthForm.value.thirtyDaysIncapable ||
    //   (this.healthForm.value.thirtyDaysIncapable == '0' && !this.healthForm.value.thirtyDaysIncapableDescription) ||
    //   !this.healthForm.value.levelOfInvaliditet ||
    //   (this.healthForm.value.levelOfInvaliditet == '0' && !this.healthForm.value.levelOfInvaliditetDescription) ||
    //   !this.healthForm.value.nameOfDoctor ||
    //   (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription) ||
    //   !this.healthForm.value.agreeToHealthQuestionnaire
    // ) {
    //   helthBool = true;
    // } else {
    //   helthBool = false;
    // }


    // console.log(mobileRegex.test(this.basicInfo.data.contractorPhonenumber.toString()))
    // console.log(offer)
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      switch (this.selectedPackage) {
        case 1:
          this.offerModelFull.data.PremiumRate = this.sentInformation.premiumRate[0];
          this.offerModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[0];
          this.offerModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[0];
          this.offerModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[0];
          this.offerModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[0];
          this.offerModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[0];
          this.offerModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[0];
          this.offerModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[0];
          break;
        case 2:
          this.offerModelFull.data.PremiumRate = this.sentInformation.premiumRate[1];
          this.offerModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[1];
          this.offerModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[1];
          this.offerModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[1];
          this.offerModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[1];
          this.offerModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[1];
          this.offerModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[1];
          this.offerModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[1];
          break;
        case 3:
          this.offerModelFull.data.PremiumRate = this.sentInformation.premiumRate[2];
          this.offerModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[2];
          this.offerModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[2];
          this.offerModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[2];
          this.offerModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[2];
          this.offerModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[2];
          this.offerModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[2];
          this.offerModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[2];
          break;
        case 4:
          this.offerModelFull.data.PremiumRate = this.sentInformation.premiumRate[3];
          this.offerModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[3];
          this.offerModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[3];
          this.offerModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[3];
          this.offerModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[3];
          this.offerModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[3];
          this.offerModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[3];
          this.offerModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[3];
          break;
        case 5:
          this.offerModelFull.data.PremiumRate = this.sentInformation.premiumRate[4];
          this.offerModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[4];
          this.offerModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[4];
          this.offerModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[4];
          this.offerModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[4];
          this.offerModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[4];
          this.offerModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[4];
          this.offerModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[4];
          break;
        case 6:
          this.offerModelFull.data.PremiumRate = this.sentInformation.premiumRate[5];
          this.offerModelFull.data.SumInsured = this.sentInformation.sumInsuredDeath[5];
          this.offerModelFull.data.DeathByAccident = this.sentInformation.sumInsuredDeathByAccident[5];
          this.offerModelFull.data.AdditionalILSumInsured = this.sentInformation.additionalSumInsuredIllness[5];
          this.offerModelFull.data.AdditionalILPremiumRate = this.sentInformation.additionalPremiumRateIllness[5];
          this.offerModelFull.data.AdditionalBFSumInsured = this.sentInformation.additionalSumInsuredBoneFracture[5];
          this.offerModelFull.data.AdditionalBFPremiumRate = this.sentInformation.additionalPremiumRateBoneFracture[5];
          this.offerModelFull.data.AdditionalASPremiumRate = this.sentInformation.additionalPremiumRateAssistance[5];
          break;
        default:
          break;
      }

      // console.log(this.supplementaryIsnuranceHideAllBool)
      // if (this.offerModelFull.data.SumInsured == 0) {
      //   this.offerModelFull.data.AdditionalILSumInsured = 0;
      //   this.offerModelFull.data.AdditionalILPremiumRate = 0;
      //   this.offerModelFull.data.AdditionalBFSumInsured = 0;
      //   this.offerModelFull.data.AdditionalBFPremiumRate = 0;
      //   this.offerModelFull.data.AdditionalASPremiumRate = 0;
      // } else {
      // }

      if (!this.userSignature) {
        this.errorTitle = "Nemate potpis";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (
          this.offerModelFull.data.PremiumRate == 12.9 &&
          ((this.insuranceCoverageBool.value.thesisDisease && !this.insuranceCoverageBool.value.brokenBone && !this.insuranceCoverageBool.value.assisstent) || (!this.insuranceCoverageBool.value.thesisDisease && this.insuranceCoverageBool.value.brokenBone && !this.insuranceCoverageBool.value.assisstent) || (!this.insuranceCoverageBool.value.thesisDisease && !this.insuranceCoverageBool.value.brokenBone && this.insuranceCoverageBool.value.assisstent))
        ) {
          this.errorTitle = "Ukoliko je premija 12.9, ne može samo jedno dopnusko pokriće biti štiklirano";
          this.modalService.open(this.alertModal, { centered: true })
        } else {



          let mobileRegex = new RegExp('[0-9]{7,9}')
          if (this.basicInfo.data.contractorType == '1') {
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || !this.basicInfo.data.contractorPIB || !this.basicInfo.data.contractorResponsibleName || !this.basicInfo.data.contractorID || this.basicInfo.data.contractorJMBG.length != 13 || this.basicInfo.data.contractorPIB.length != 9 || this.basicInfo.data.contractorID.length != 8) {
              this.digitalService.addInfo(true);
            } else {
              if (!this.basicInfo.data.insuredFirstname || !this.basicInfo.data.insuredLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                this.digitalService.addInfo(true);
              } else {
                if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.indexation || !this.insuredSumAndPremiumForm.value.methodPayment) {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      if (!this.fatcaForm.value.insuredLegalEntitySad || !this.fatcaForm.value.insuredTaxpayerSad || !this.fatcaForm.value.insuredTenPrecentShare || !this.fatcaForm.value.insuredFinancialInstitution) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname || !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13) {
              console.log("Prosle basic")
              console.log(this.basicInfo)
              this.digitalService.addInfo(true);
            } else {
              if (!this.basicInfo.data.insuredFirstname || !this.basicInfo.data.insuredLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                console.log(this.basicInfo.data)
                console.log('prosole insured')
                this.digitalService.addInfo(true);
              } else {
                if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.indexation || !this.insuredSumAndPremiumForm.value.methodPayment) {
                  this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                  this.validInsuranceAndSumPremium = true;
                } else {
                  console.log("Prosle currency")
                  if (this.userValue) {
                    this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.calculcatorUsersBool = true;
                    this.validUser = true
                  } else {
                    console.log("Prosli korisnici")
                    if (helthBool) {
                      this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.healthQuestionnaireBool = true;
                    } else {
                      console.log("Prosao zdravstveni")
                      if (!this.fatcaForm.value.citizenshipSad || !this.fatcaForm.value.texpayerSad) {
                        this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.noticeFatcaBool = true;
                      } else {
                        if (
                          !this.spnftForm.value.firstname ||
                          !this.spnftForm.value.lastname ||
                          !this.spnftForm.value.jmbg ||
                          !this.spnftForm.value.settlementob ||
                          !this.spnftForm.value.address ||
                          !this.spnftForm.value.postalCode ||
                          !this.spnftForm.value.citizenship ||
                          !this.spnftForm.value.numberOfDocument ||
                          !this.spnftForm.value.typeOfDocument ||
                          !this.spnftForm.value.dateOfIssuringDocument ||
                          !this.spnftForm.value.personalDocumentExpirationDate ||
                          !this.spnftForm.value.placeOfIssuringDocument ||
                          !this.spnftForm.value.cutomerAnotherPerson ||
                          (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                          (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                          !this.spnftForm.value.purposeOfBusinessRelation ||
                          (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                          !this.spnftForm.value.originOfProperty ||
                          (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                        ) {
                          this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.validSPNFT = true;
                          this.formSpnftBool = true;
                        } else {
                          console.log("Prosao spnft")
                          if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                            if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                              this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                              this.validPLATIMATIK = true;
                              this.formPlatimatikBool = true
                            } else {
                              console.log("Prosao platiomatik")
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true })
                              }
                            }
                          } else {
                            if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                              console.log("Mogu da se posalju podaci!")
                              this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                            } else {
                              this.errorTitle = "Morate da potvrdite saglasnost";
                              this.modalService.open(this.alertModal, { centered: true })
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  resetCalculation() {
    this.hideExport = false;
    if (this.basicInfo.data.insuredJMBG) {
      if (this.basicInfo.data.insuredJMBG.length >= 7) {
        if (this.basicInfo.data.insuredJMBG.substring(4, 5) == '0') {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        } else {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        }
      }
    }
  }

  contractualElementsOfInsuranceHide() {
    this.contractualElementsOfInsuranceBool = !this.contractualElementsOfInsuranceBool;
  }
  basicCoveredHide() {
    this.basicCoveredBool = !this.basicCoveredBool;
  }
  supplementaryCoveredHide() {
    this.supplementaryCoveredBool = !this.supplementaryCoveredBool;
  }
  calculcatorUsersHide() {
    this.calculcatorUsersBool = !this.calculcatorUsersBool;
  }
  healthQuestionnaireHide() {
    this.healthQuestionnaireBool = !this.healthQuestionnaireBool;
  }
  noticePersonalityHide() {
    this.noticePersonalityBool = !this.noticePersonalityBool;
  }
  noticeFatcaHide() {
    this.noticeFatcaBool = !this.noticeFatcaBool;
  }
  formSpnftHide() {
    this.formSpnftBool = !this.formSpnftBool;
  }
  formPlatimatikHide() {
    this.formPlatimatikBool = !this.formPlatimatikBool;
  }
  noSupplementaryHide() {
    this.supplementaryIsnuranceHideAllBool = !this.supplementaryIsnuranceHideAllBool;
    if (this.supplementaryIsnuranceHideAllBool) {
      this.insuranceSumForm.get('sumPremiumRate').setValue(this.sentInformation.premiumRate[this.selectedPackage - 1].toFixed(2));
      this.insuranceSumForm.get('sumYearly').setValue((this.sentInformation.premiumRate[this.selectedPackage - 1].toFixed(2) * parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment)).toFixed(2));
    } else {
      let calc = this.PremiumRate[this.selectedPackage - 1];
      if (this.insuranceCoverageBool.value.thesisDisease) {
        calc += this.AdditionalPremiumRateIllness[this.selectedPackage - 1];
      }
      if (this.insuranceCoverageBool.value.brokenBone) {
        calc += this.AdditionalPremiumRateBoneFracture[this.selectedPackage - 1];
      }
      if (this.insuranceCoverageBool.value.assisstent) {
        calc += this.AdditionalPremiumRateAssistance[this.selectedPackage - 1];
      }
      this.insuranceSumForm.get('sumPremiumRate').setValue(calc);
      this.insuranceSumForm.get('sumYearly').setValue((calc * parseInt(this.insuredSumAndPremiumForm.value.dynamicOfPayment)).toFixed(2));
    }
    this.resetCalculation()
  }

  roles;
  getRoles(num) {
    // this.roles = this.productRoleService.getRoleByProduct(num)
    this.productRoleService.getRoleByProduct(num)
      .subscribe(
        (res) => {
          this.roles = res;
          console.log(this.roles)
        }
      )
  }

  get validInsuredSumAndPremiumForm() {
    return this.insuredSumAndPremiumForm.controls;
  }

  get validHealthForm() {
    return this.healthForm.controls;
  }

  setSPNFTDate() {
    if (this.spnftForm.value.jmbg.length >= 7) {
      if (this.spnftForm.value.jmbg.substring(4, 5) == '0') {
        this.spnftForm.get('dob').setValue(this.spnftForm.value.jmbg.substring(0, 2) + "." + this.spnftForm.value.jmbg.substring(2, 4) + '.2' + this.spnftForm.value.jmbg.substring(4, 7))
      } else {
        this.spnftForm.get('dob').setValue(this.spnftForm.value.jmbg.substring(0, 2) + "." + this.spnftForm.value.jmbg.substring(2, 4) + '.1' + this.spnftForm.value.jmbg.substring(4, 7))
      }
    } else {
      this.spnftForm.get('dob').setValue('')
    }
  }

  setdobOnBehalf() {
    if (this.spnftForm.value.jmbgOnBehalf.length >= 7) {
      if (this.spnftForm.value.jmbgOnBehalf.substring(4, 5) == '0') {
        this.spnftForm.get('dobOnBehalf').setValue(this.spnftForm.value.jmbgOnBehalf.substring(0, 2) + "." + this.spnftForm.value.jmbgOnBehalf.substring(2, 4) + '.2' + this.spnftForm.value.jmbgOnBehalf.substring(4, 7))
      } else {
        this.spnftForm.get('dobOnBehalf').setValue(this.spnftForm.value.jmbgOnBehalf.substring(0, 2) + "." + this.spnftForm.value.jmbgOnBehalf.substring(2, 4) + '.1' + this.spnftForm.value.jmbgOnBehalf.substring(4, 7))
      }
    } else {
      this.spnftForm.get('dobOnBehalf').setValue('')
    }
  }

  userId;
  userSignature;
  getUser() {
    this.userService.getUser()
      .then(
        (x: { id: Number, signature: String }) => {
          this.userId = x.id;
          this.userSignature = x.signature;
        }
      )
  }


  resetEverything() {
    this.insuredSumAndPremiumForm.reset({ currencyPayment: '0', currencyPayout: '0', insuranceEnd: 'DOŽIVOTNO', dynamicOfPayment: '12', offer: true, proContract: false, terms: false })
    this.todayDate = new Date()
    this.todayDate.setDate(1);
    this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.healthForm.reset()
    this.insuranceSumForm.reset({ sumPremiumRate: '', sumYearly: '' });
    this.fatcaForm.reset({
      citizenshipSad: '1',
      texpayerSad: '1',
      insuredLegalEntitySad: '1',
      insuredTaxpayerSad: '1',
      insuredTenPrecentShare: '1',
      insuredFinancialInstitution: '1'
    })
    this.packegeOnePremiumRate = null;
    this.packegeOneInsuranceSum = null;
    this.packegeOneInsuranceSumDeath = null;
    this.packegeTwoPremiumRate = null;
    this.packegeTwoInsuranceSum = null;
    this.packegeTwoInsuranceSumDeath = null;
    this.packegeThreePremiumRate = null;
    this.packegeThreeInsuranceSum = null;
    this.packegeThreeInsuranceSumDeath = null;
    this.packegeFourPremiumRate = null;
    this.packegeFourInsuranceSum = null;
    this.packegeFourInsuranceSumDeath = null;
    this.packegeFivePremiumRate = null;
    this.packegeFiveInsuranceSum = null;
    this.packegeFiveInsuranceSumDeath = null;
    this.packegeSixPremiumRate = null;
    this.packegeSixInsuranceSum = null;
    this.packegeSixInsuranceSumDeath = null;

    this.packageOneThesisDiseaseFirst = null;
    this.packageOneThesisDiseaseSecond = null;
    this.packageOneBrokenBonesFirst = null;
    this.packageOneBrokenBonesSecond = null;
    this.packageOneAssisstent = null;
    this.packageTwoThesisDiseaseFirst = null;
    this.packageTwoThesisDiseaseSecond = null;
    this.packageTwoBrokenBonesFirst = null;
    this.packageTwoBrokenBonesSecond = null;
    this.packageTwoAssisstent = null;
    this.packageThreeThesisDiseaseFirst = null;
    this.packageThreeThesisDiseaseSecond = null;
    this.packageThreeBrokenBonesFirst = null;
    this.packageThreeBrokenBonesSecond = null;
    this.packageThreeAssisstent = null;
    this.packageFourThesisDiseaseFirst = null;
    this.packageFourThesisDiseaseSecond = null;
    this.packageFourBrokenBonesFirst = null;
    this.packageFourBrokenBonesSecond = null;
    this.packageFourAssisstent = null;
    this.packageFiveThesisDiseaseFirst = null;
    this.packageFiveThesisDiseaseSecond = null;
    this.packageFiveBrokenBonesFirst = null;
    this.packageFiveBrokenBonesSecond = null;
    this.packageFiveAssisstent = null;
    this.packageSixThesisDiseaseFirst = null;
    this.packageSixThesisDiseaseSecond = null;
    this.packageSixBrokenBonesFirst = null;
    this.packageSixBrokenBonesSecond = null;
    this.packageSixAssisstent = null;
    this.spnftForm.reset({ officialCloseFamily: '0' })
    this.platimatikForm.reset()
    this.hideExport = false;
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.checkBoxesForm.reset({ confirmVeracity: false, confirmData: false, confirmSMS: '1', confirmEmail: '1' })
    this.removeInfoService.sendOfferID(true);
    this.insuranceUsers = []
    this.validInsuranceAndSumPremium = false;
    this.validUser = false;
    this.validSPNFT = true;
    this.validPLATIMATIK = false;
    this.calculcatorUsersBool = false;
    this.noticePersonalityBool = false;
    this.noticeFatcaBool = false;
    this.formSpnftBool = false;
    this.basicInfo = new BasicInformations({});
  }

}
